import React, { Component, Fragment, useState } from "react";
import Sticky from "Components/Sticky/index";
import Dropdown from "Components/Dropdown/dropdown";
import { ReactComponent as Back } from 'Icons/back.svg'
import Checkbox from "Components/Checkbox/index";
import Popup from 'reactjs-popup';
import 'reactjs-popup/dist/index.css';
import { AiOutlineCloseCircle, AiOutlinePlusCircle, AiOutlinePlus, } from "react-icons/ai";
import { BsPlusSquareFill } from "react-icons/bs";
import { IoIosArrowDropdown, IoIosArrowDropup } from "react-icons/io";
import { TiDelete } from "react-icons/ti"
import Input from "Components/FormInput/formInput";
import { GENERATE_PLAN_IN_MASTER_CONTRACT, GET_FROM_ROUTE, GET_GENERATE_ROUTE_CODE, POST_SEARCH_ROUTES_CONTRACTS, GET_LOCATION_DROPDOWN_VALUES, GET_ALL_SUBPLANTS, TOAST_ERROR, START_LOADER, END_LOADER } from "Constants/actionConstants";
import { getUser } from 'Utils/storage';
import { connect } from "react-redux";
import { withRouter } from "react-router";
import moment from 'moment';
import ActionLoader from "Components/ActionLoader/index";
import MultipleDropdown from "Components/MultipleDropdown/index";
import { DateRangePicker } from "react-dates";
import classNames from 'classnames';
import { isCoromandel, isEmami } from "Utils/index";
import { screenInfoDetails } from "Constants/screenInfoDetailsConstants";
import ScreenTimeTrack from "Components/Common/ScreenTimeTrack/index";

const ROW_HEADINGS = {
  transporters: "Transporters",
  surveyors: "Surveyors",
  handling_agents: "Handling Agents",
  lashers: "Lashers",
  securities: "Security"
}

const arrayKeys = {
  source: 'fromArray',
  origin_yard: 'originYardArray',
  destination: 'toArray',
  destination_yard: 'destinationYardArray'
}

class CreateNewContracts extends Component {
  constructor(props) {

    super(props);
    this.state = {
      wagon: "",
      wagonWt: "",
      selectedArray: [],
      selectedArray2: [],
      selectedArray3: [],
      selectedArray4: [],
      selectedArray5: [],
      selectedArray6: [],
      routeData: [],
      allSelected: true,
      destinationYardFull: [{
        route_code: null,
        from: null,
        origin_yard: null,
        to: null,
        destination_yard: null
      }],
      DATARAIL: [],
      values: [
        {
          id: 1,
          rake: "Rake",
          commodityCategory: "Commodity Category",
          commodityName: "Commodity Name",
          typeWagon: "Type of Wagon",
          numberWagonn: "No. of Wagon",
          weightWagon: "Wagon Wt."
        }
      ],
      isCheckAll: "false",
      checkedBlue: false,
      transporter: [
        { id: 1, value: "Transporter 1", isChecked: false },
        { id: 2, value: "Transporter 2", isChecked: false },
        { id: 3, value: "Transporter 3", isChecked: false },
      ],
      OriginData: [
        {
          allName: [
            { name1: "Transporters" },
            { name2: "Surveyors" },
            { name3: "Handling Agents" },
            { name4: "Security" }
          ],
          L1: [
            { name1: "Transporter 1", Rate: 4000, SAP: 454567, Contract: "26 Mar To 26 Sep 2022" },
            { name2: "Surveyor 1", Rate: 200, SAP: 454568, Contract: "26 Mar To 26 Sep 2022" },
            { name3: "Handling Agents 1", Rate: 300, SAP: 454569, Contract: "26 Mar To 26 Sep 2022" },
            { name4: "Security 1", Rate: 290, SAP: 454570, Contract: "26 Mar To 26 Sep 2022" }
          ],
          L2: [
            { name2: "Transporter 2", Rate: 4000 },
            { name2: "Surveyor 2", Rate: 200 },
            { name2: "Handling Agents 2", Rate: 300 },
            { name2: "Security 2", Rate: 290 }
          ],
          L3: [
            { name3: "Transporter 3", Rate: 4000 },
            { name3: "Surveyor 3", Rate: 200 },
            { name3: "Handling Agents 3", Rate: 300 },
            { name3: "Security 3", Rate: 290 }
          ],
        }
      ],
      allData: [
        { id: 44, name: "Transporters", check1: "Transporter 1", check2: "Transporter 2", check3: "Transporter 3", Rate: 4500, Rate2: 4000, Rate3: 300, Contract_No: 454567, date: "26 Mar 2022 To 26 Sep 2022" },
        { id: 45, name: "Surveyors", check1: "Surveyor 1", check2: "Surveyor 2", check3: "Surveyor 3", Rate: 200, Rate2: 3000, Rate3: 200, Contract_No: 454568, date: "26 Mar 2022 To 26 Sep 2022" },
        { id: 46, name: "Handling Agents", check1: "Handling Agents 1", check2: "Handling Agents 2", check3: "Handling Agents 3", Rate: 210, Rate2: 2000, Rate3: 150, Contract_No: 454569, date: "26 Mar 2022 To 26 Sep 2022" },
        { id: 47, name: "Lashers", check1: "Lashers 1", check2: "Lashers 2", check3: "Lashers 3", Rate: 280, Rate2: 290, Rate3: 300, Contract_No: 454569, date: "26 Mar 2022 To 26 Sep 2022" },
        { id: 48, name: "Security", check1: "Security 1", check2: "Security 2", check3: "Security 3", Rate: 300, Rate2: 1000, Rate3: 100, Contract_No: 454570, date: "26 Mar 2022 To 26 Sep 2022" }
      ],
      allData2: [
        { id: 44, name: "Transporters", check1: "Transporter 1", check2: "Transporter 2", check3: "Transporter 3", Rate: 4500, Contract_No: 454567, date: "26 Mar 2022 To 26 Sep 2022" },
        { id: 45, name: "Surveyors", check1: "Surveyor 1", check2: "Surveyor 2", check3: "Surveyor 3", Rate: 200, Contract_No: 454568, date: "26 Mar 2022 To 26 Sep 2022" },
        { id: 46, name: "Handling Agents", check1: "Handling Agents 1", check2: "Handling Agents 2", check3: "Handling Agents 3", Rate: 210, Contract_No: 454569, date: "26 Mar 2022 To 26 Sep 2022" },
        { id: 47, name: "Lashers", check1: "Lashers 1", check2: "Lashers 2", check3: "Lashers 3", Rate: 280, Rate2: 290, Rate3: 300, Contract_No: 454569, date: "26 Mar 2022 To 26 Sep 2022" },
        { id: 48, name: "Security", check1: "Security 1", check2: "Security 2", check3: "Security 3", Rate: 300, Contract_No: 454570, date: "26 Mar 2022 To 26 Sep 2022" }
      ],
      allData3: [
        { id: 44, name: "Transporters", check1: "Transporter 1", check2: "Transporter 2", check3: "Transporter 3", Rate: 4500, Contract_No: 454567, date: "26 Mar 2022 To 26 Sep 2022" },
        { id: 45, name: "Surveyors", check1: "Surveyor 1", check2: "Surveyor 2", check3: "Surveyor 3", Rate: 200, Contract_No: 454568, date: "26 Mar 2022 To 26 Sep 2022" },
        { id: 46, name: "Handling Agents", check1: "Handling Agents 1", check2: "Handling Agents 2", check3: "Handling Agents 3", Rate: 210, Contract_No: 454569, date: "26 Mar 2022 To 26 Sep 2022" },
        { id: 47, name: "Lashers", check1: "Lashers 1", check2: "Lashers 2", check3: "Lashers 3", Rate: 280, Rate2: 290, Rate3: 300, Contract_No: 454569, date: "26 Mar 2022 To 26 Sep 2022" },
        { id: 48, name: "Security", check1: "Security 1", check2: "Security 2", check3: "Security 3", Rate: 300, Contract_No: 454570, date: "26 Mar 2022 To 26 Sep 2022" }
      ],
      allData4: [
        { id: 44, name: "Transporters", check1: "Transporter 1", check2: "Transporter 2", check3: "Transporter 3", Rate: 4500, Contract_No: 454567, date: "26 Mar 2022 To 26 Sep 2022" },
        { id: 45, name: "Surveyors", check1: "Surveyor 1", check2: "Surveyor 2", check3: "Surveyor 3", Rate: 200, Contract_No: 454568, date: "26 Mar 2022 To 26 Sep 2022" },
        { id: 46, name: "Handling Agents", check1: "Handling Agents 1", check2: "Handling Agents 2", check3: "Handling Agents 3", Rate: 210, Contract_No: 454569, date: "26 Mar 2022 To 26 Sep 2022" },
        { id: 47, name: "Lashers", check1: "Lashers 1", check2: "Lashers 2", check3: "Lashers 3", Rate: 280, Rate2: 290, Rate3: 300, Contract_No: 454569, date: "26 Mar 2022 To 26 Sep 2022" },
        { id: 48, name: "Security", check1: "Security 1", check2: "Security 2", check3: "Security 3", Rate: 300, Contract_No: 454570, date: "26 Mar 2022 To 26 Sep 2022" }
      ],
      allData5: [
        { id: 44, name: "Transporters", check1: "Transporter 1", check2: "Transporter 2", check3: "Transporter 3", Rate: 4500, Contract_No: 454567, date: "26 Mar 2022 To 26 Sep 2022" },
        { id: 45, name: "Surveyors", check1: "Surveyor 1", check2: "Surveyor 2", check3: "Surveyor 3", Rate: 200, Contract_No: 454568, date: "26 Mar 2022 To 26 Sep 2022" },
        { id: 46, name: "Handling Agents", check1: "Handling Agents 1", check2: "Handling Agents 2", check3: "Handling Agents 3", Rate: 210, Contract_No: 454569, date: "26 Mar 2022 To 26 Sep 2022" },
        { id: 47, name: "Lashers", check1: "Lashers 1", check2: "Lashers 2", check3: "Lashers 3", Rate: 280, Rate2: 290, Rate3: 300, Contract_No: 454569, date: "26 Mar 2022 To 26 Sep 2022" },
        { id: 48, name: "Security", check1: "Security 1", check2: "Security 2", check3: "Security 3", Rate: 300, Contract_No: 454570, date: "26 Mar 2022 To 26 Sep 2022" }
      ],
      allData6: [
        { id: 44, name: "Transporters", check1: "Transporter 1", check2: "Transporter 2", check3: "Transporter 3", Rate: 4500, Contract_No: 454567, date: "26 Mar 2022 To 26 Sep 2022" },
        { id: 45, name: "Surveyors", check1: "Surveyor 1", check2: "Surveyor 2", check3: "Surveyor 3", Rate: 200, Contract_No: 454568, date: "26 Mar 2022 To 26 Sep 2022" },
        { id: 46, name: "Handling Agents", check1: "Handling Agents 1", check2: "Handling Agents 2", check3: "Handling Agents 3", Rate: 210, Contract_No: 454569, date: "26 Mar 2022 To 26 Sep 2022" },
        { id: 47, name: "Lashers", check1: "Lashers 1", check2: "Lashers 2", check3: "Lashers 3", Rate: 280, Rate2: 290, Rate3: 300, Contract_No: 454569, date: "26 Mar 2022 To 26 Sep 2022" },
        { id: 48, name: "Security", check1: "Security 1", check2: "Security 2", check3: "Security 3", Rate: 300, Contract_No: 454570, date: "26 Mar 2022 To 26 Sep 2022" }
      ],
      routeCode: [],
      from: [],
      to: [],
      originYard: [],
      destination_Yard: [],
      rakeOf: [],
      commodity_cato: [],
      commodity_N: [],
      WagonType: [],
      routecodeData: [],
      locationDropdownValues: [
        {
          fromArray: [],
          toArray: [],
          originYardArray: [],
          destinationYardArray: []
        }
      ],
      multipleOriginYard: [{
        originYard: "Origin Yard",
      }],
      multipleDestinationYard: [{
        destinationYard: "Destination Yard",
      }],
      selectedSubPlants:[],
      routeDetails: []
    };

    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleInput2Change = this.handleInput2Change.bind(this);
  }

  componentDidMount() {
    // this.getFromRoutesData();
    this.getRouteCodeData(null, 0);
    this.getAllSubPlants()
  }
  componentDidUpdate(prevProps, prevState, snapshot){
    const {allSubPlants} = this.props
    if (this.props.allSubPlants !== prevProps.allSubPlants) {
         let updateAllSubPlants = allSubPlants.map((ele)=>{
          return {
            ...ele,
            isSelected:true
          }
         })
       this.setState({selectedSubPlants: updateAllSubPlants})
    }
  }
  getAllSubPlants = () => {
    const { dispatch } = this.props;
    const branchLocalName = localStorage.getItem('branchDetail'); 
    const name = (branchLocalName && branchLocalName.length > 0) ? JSON.parse(localStorage.getItem('branchDetail')) : '';
    const user = getUser();
    dispatch({ type: START_LOADER });
    dispatch({
        type: GET_ALL_SUBPLANTS,
        params: {
            branchName: name ? name.branch_name : user.branchName,
            branchId: name ? name.branch_id : user.branchId
        },
        onSuccess: () => dispatch({ type: END_LOADER }),
        onError: () => dispatch({ type: END_LOADER })
    })
  }

  handleCoromandelRouteCodeResponse = (resp, idx, type) => {
    const apiData = resp?.source_des_list || [];
    const { destinationYardFull } = JSON.parse(JSON.stringify(this.state));

    if (type === 'setRouteCode' && apiData.length && apiData[0].sap_code) {
      destinationYardFull[idx].route_code = apiData[0].sap_code;
    }

    const uniqueRoutes = [
      ...new Map(apiData.map(item => [item.sap_code, item])).values()
    ];

    const routes = this.state.routecodeData || [];
    const tempRoutes = [...routes];
    tempRoutes[idx] = uniqueRoutes;

    this.setState({
      routecodeData: tempRoutes,
      destinationYardFull,
      routeDetails: apiData
    });
  };



  getRouteCodeData = (search, idx, type, locationObj) => {
    const { dispatch } = this.props;
    const user = getUser();
    const data = {
      companyId: user.id,
      ...(search ? { search } : {}),
      ...(type && type == 'setRouteCode' ? {
        from: locationObj.from,
        to: locationObj.to,
        originYard: locationObj.origin_yard,
        destinationYard: locationObj.destination_yard
      } : {})
    }
    dispatch({ type: START_LOADER });
    dispatch({
      type: GET_GENERATE_ROUTE_CODE,
      params: data,
      onSuccess: (data) => {
        dispatch({ type: END_LOADER });
        if (isCoromandel()) {
          this.handleCoromandelRouteCodeResponse(data, idx, type);
          return;
        }
        if(isEmami()) {
          // this.setState({
          //   routeDetails: data || []
          // })
          const { destinationYardFull } = JSON.parse(JSON.stringify(this.state));
          if (type && type == 'setRouteCode' && data && data.length && data[0].cluster_code){
            destinationYardFull[idx].route_code = data[0].cluster_code;
          }
          const routes = this.state.routecodeData
          let tempRoutes = [...routes]
          tempRoutes[idx] = [...new Map(((data || {}).source_dest_routes || []).map((m) => [m['cluster_code'], m])).values()] 
          this.setState({
            routecodeData: tempRoutes,
            destinationYardFull,
            routeDetails: data || {}
          })
        } else {
          const { destinationYardFull } = JSON.parse(JSON.stringify(this.state));
          if (type && type == 'setRouteCode' && data && data.length && data[0].sap_code){
            destinationYardFull[idx].route_code = data[0].sap_code;
          }

          const routes = this.state.routecodeData
          let tempRoutes = [...routes]
          tempRoutes[idx] = [...new Map(data.map((m) => [m['sap_code'], m])).values()] 
          this.setState({
            routecodeData: tempRoutes,
            destinationYardFull
          })
        }
      },
      onError: () => dispatch({ type: END_LOADER })
    })
  }

  getLocationValues = (search, idx, key, type) => {
    const { dispatch } = this.props;
    const user = getUser();
    const data = {
      companyId: user.id,
      ...(search ? { search } : {}),
      type
    }

      dispatch({ type: START_LOADER });
      dispatch({
        type: GET_LOCATION_DROPDOWN_VALUES,
        params: data,
        onSuccess: (data) => {
          dispatch({ type: END_LOADER });
          const dropdownValues = this.state.locationDropdownValues
          let tempDropdownValues = [...dropdownValues]

          const arrayKey = arrayKeys[key] || 'fromArray'

          tempDropdownValues[idx][arrayKey] = (data || []).map(val=>{
            return { [key]: val }
          })

          this.setState({ locationDropdownValues: tempDropdownValues })
        },
        onError: () => dispatch({ type: END_LOADER })
      })

  }

    getFromRoutesData = (item, index, type) => {
    const { dispatch } = this.props;
    let { routeCode } = this.state;
    const user = getUser();
    const data = {
      companyId: user.id,
      routeCode: item ? item : undefined
    }
    dispatch({ type: START_LOADER });
    dispatch({
      type: GET_FROM_ROUTE,
      params: data,
      onSuccess: (data) => {
        dispatch({ type: END_LOADER });
        const dropdownValues = this.state.locationDropdownValues;
        let tempDropdownValues = [...dropdownValues];
        tempDropdownValues[index].fromArray = [...new Map(data.map((m) => [m['source'], m])).values()];
        tempDropdownValues[index].originYardArray = [...new Map(data.map((m) => [m['origin_yard'], m])).values()];
        tempDropdownValues[index].toArray = [...new Map(data.map((m) => [m['destination'], m])).values()];
        tempDropdownValues[index].destinationYardArray = [...new Map(data.map((m) => [m['destination_yard'], m])).values()];
        this.setState({
          // ...(type !== 'autofill' ? { routecodeData: data } : {}),
          locationDropdownValues: tempDropdownValues
        }, () => {
          if (type === 'autofill') {
          const { destinationYardFull, locationDropdownValues } = JSON.parse(JSON.stringify(this.state));

            destinationYardFull[index].from = locationDropdownValues[index].fromArray[0].source;
              destinationYardFull[index].to = locationDropdownValues[index].toArray[0].destination;
              destinationYardFull[index].origin_yard = locationDropdownValues[index].originYardArray[0].origin_yard;
              destinationYardFull[index].destination_yard = locationDropdownValues[index].originYardArray[0].destination_yard;
              
              this.setState({ destinationYardFull });
            }
            })
      },
      onError: () => dispatch({ type: END_LOADER })
    })
  }

  handleChange(i, e) {
    let Values = this.state.values;
    Values[i][e.target.name] = e.target.value;
    this.setState({ values });
  }


  addFields() {
    this.setState(({
      values: [...this.state.values, {
        rake: "Rake",
        commodityCategory: "Commodity Category",
        commodityName: "Commodity Name",
        typeWagon: "Type of Wagon",
        numberWagonn: "No. of Wagon",
        weightWagon: "Wagon Wt."
      }]
    }))
  }

  addNewRouteCode() {
    this.setState(({
      destinationYardFull: [...this.state.destinationYardFull, {
        route_code: null,
        from: null,
        origin_yard: null,
        destination_yard: null,
        to: null
      }],
      routecodeData: [...this.state.routecodeData, []],
      locationDropdownValues: [...this.state.locationDropdownValues, {
        fromArray: [],
        toArray: [],
        originYardArray: [],
        destinationYardArray: []
      }]
    }), ()=>{
      this.getRouteCodeData(null, this.state.routecodeData.length - 1)
    })
  }

  addOriginYard = () => {
    this.setState(({
      multipleOriginYard: [...this.state.multipleOriginYard, {
        originYard: "Origin Yard",
      }]
    }))
  }

  removeOriginYard(i) {
    let multipleOriginYard = this.state.multipleOriginYard;
    multipleOriginYard.splice(i, 1);
    this.setState({ multipleOriginYard });
  }

  addDestinationYard = () => {
    this.setState(({
      multipleDestinationYard: [...this.state.multipleDestinationYard, {
        destinationYard: "Destination Yard",
      }]
    }))
  }

  removeDestinationYard(i) {
    let multipleDestinationYard = this.state.multipleDestinationYard;
    multipleDestinationYard.splice(i, 1);
    this.setState({ multipleDestinationYard });
  }

  searchRoutesMasterContract = () => { //SEARCH ROUTE FOR MASTER CONTRACT
    const { dispatch } = this.props;
    const { destinationYardFull, startDate, endDate } = JSON.parse(JSON.stringify(this.state));
    const user = getUser();
    const data = {
      companyId: user.id
    }

    let tempData = [...destinationYardFull]

    tempData.forEach((fullData)=>{
      if(fullData.origin_yard){
        fullData.origin_yard = [`${fullData.origin_yard}`];
      }
      if(fullData.destination_yard){
        fullData.destination_yard = [`${fullData.destination_yard}`];
      }
    })

    dispatch({ type: START_LOADER });
    dispatch({
      type: POST_SEARCH_ROUTES_CONTRACTS,
      params: data,
      data: {
        contract_tenure_from: new Date(moment(startDate)).setHours(0, 0, 0, 0),
        contract_tenure_to: new Date(moment(endDate)).setHours(23, 59, 59),
        list: tempData
      },
      onSuccess: (data) => {
        dispatch({ type: END_LOADER });
        this.setState({
          routeData: [...data]
        })
      },
      onError: () => dispatch({ type: END_LOADER })
    })
  }

  removeDestionationYard(i) {
    let destinationYardFull = this.state.destinationYardFull;
    let routecodeData = this.state.routecodeData;
    let locationDropdownValues = this.state.locationDropdownValues;
    destinationYardFull.splice(i, 1);
    routecodeData.splice(i, 1);
    locationDropdownValues.splice(i, 1);
    this.setState({ destinationYardFull, routecodeData, locationDropdownValues });
  }

  unCheck(i) {
    let ref = 'ref_' + i;
    this.refs[ref].checked = !this.refs[ref].checked;
  }

  removeFields(i) {
    let Values = this.state.values;
    Values.splice(i, 1);
    this.setState({ Values });
  }

  checkedFullRow = (ele) => {
    const { selectedArray } = this.state;
    const temp = [...selectedArray]
    if (temp.find(obj => obj.id === ele.id)) {
      temp.splice(temp.findIndex(obj => obj.id === ele.id), 1)
      this.setState({ selectedArray: temp })
    } else {
      temp.push(ele)
      this.setState({ selectedArray: temp })
    }
  }

  checkSingleElement = (parentId, heading, subHeading, childId) => {
    const data = JSON.parse(JSON.stringify(this.state.routeData))
    let tempRouteData = data;
    let selectedChild = tempRouteData[parentId][heading][subHeading][childId];

    selectedChild.is_selected = selectedChild.is_selected ? selectedChild.is_selected === true ? false : true : true;

    tempRouteData[parentId][heading][subHeading][childId] = selectedChild

    this.setState({ routeData: tempRouteData })

  }

  checkedFullRow2 = (ele) => {
    const { selectedArray2 } = this.state;
    const temp = [...selectedArray2]
    if (temp.find(obj => obj.id === ele.id)) {
      temp.splice(temp.findIndex(obj => obj.id === ele.id), 1)
      this.setState({ selectedArray2: temp })
    } else {
      temp.push(ele)
      this.setState({ selectedArray2: temp })
    }
  }

  checkedFullRow3 = (ele) => {
    const { selectedArray3 } = this.state;
    const temp = [...selectedArray3]
    if (temp.find(obj => obj.id === ele.id)) {
      temp.splice(temp.findIndex(obj => obj.id === ele.id), 1)
      this.setState({ selectedArray3: temp })
    } else {
      temp.push(ele)
      this.setState({ selectedArray3: temp })
    }
  }

  checkedFullRow4 = (ele) => {
    const { selectedArray4 } = this.state;
    const temp = [...selectedArray4]
    if (temp.find(obj => obj.id === ele.id)) {
      temp.splice(temp.findIndex(obj => obj.id === ele.id), 1)
      this.setState({ selectedArray4: temp })
    } else {
      temp.push(ele)
      this.setState({ selectedArray4: temp })
    }
  }

  checkedFullRow5 = (ele) => {
    const { selectedArray5 } = this.state;
    const temp = [...selectedArray5]
    if (temp.find(obj => obj.id === ele.id)) {
      temp.splice(temp.findIndex(obj => obj.id === ele.id), 1)
      this.setState({ selectedArray5: temp })
    } else {
      temp.push(ele)
      this.setState({ selectedArray5: temp })
    }
  }

  checkedFullRow6 = (ele) => {
    const { selectedArray6 } = this.state;
    const temp = [...selectedArray6]
    if (temp.find(obj => obj.id === ele.id)) {
      temp.splice(temp.findIndex(obj => obj.id === ele.id), 1)
      this.setState({ selectedArray6: temp })
    } else {
      temp.push(ele)
      this.setState({ selectedArray6: temp })
    }
  }

  selectAllScheduleRecords = () => {
    const { routeCode } = this.state;
    const { selectedArray } = this.state
    let selectedSchedulesCopy = [...selectedArray]
    const value = (selectedSchedulesCopy.length !== routeCode.length);

    if (value) {
      (routeCode || []).forEach((obj) => {
        if (!selectedSchedulesCopy.find(ele => ele.id === obj.id)) {
          selectedSchedulesCopy.push(obj);
        }
      })
    }
    else {
      selectedSchedulesCopy = [];
    }
    this.setState({ selectedArray: selectedSchedulesCopy });
  }

  selectAllScheduleRecords2 = () => {
    const { allData2 } = this.state;
    const { selectedArray2 } = this.state
    let selectedSchedulesCopy = [...selectedArray2]
    const value = (selectedSchedulesCopy.length !== allData2.length);

    if (value) {
      (allData2 || []).forEach((obj) => {
        if (!selectedSchedulesCopy.find(ab => ab.id === obj.id)) {
          selectedSchedulesCopy.push(obj);
        }
      })
    } else {
      selectedSchedulesCopy = [];
    }
    this.setState({ selectedArray2: selectedSchedulesCopy });
  }

  selectAllScheduleRecords3 = () => {
    const { allData3 } = this.state;
    const { selectedArray3 } = this.state
    let selectedSchedulesCopy = [...selectedArray3]
    const value = (selectedSchedulesCopy.length !== allData3.length);

    if (value) {
      (allData3 || []).forEach((obj) => {
        if (!selectedSchedulesCopy.find(abc => abc.id === obj.id)) {
          selectedSchedulesCopy.push(obj);
        }
      })
    } else {
      selectedSchedulesCopy = [];
    }
    this.setState({ selectedArray3: selectedSchedulesCopy });
  }

  selectAllScheduleRecords4 = () => {
    const { allData4 } = this.state;
    const { selectedArray4 } = this.state
    let selectedSchedulesCopy = [...selectedArray4]
    const value = (selectedSchedulesCopy.length !== allData4.length);

    if (value) {
      (allData4 || []).forEach((obj) => {
        if (!selectedSchedulesCopy.find(abc => abc.id === obj.id)) {
          selectedSchedulesCopy.push(obj);
        }
      })
    } else {
      selectedSchedulesCopy = [];
    }
    this.setState({ selectedArray4: selectedSchedulesCopy });
  }

  selectAllScheduleRecords5 = () => {
    const { allData5 } = this.state;
    const { selectedArray5 } = this.state
    let selectedSchedulesCopy = [...selectedArray5]
    const value = (selectedSchedulesCopy.length !== allData5.length);

    if (value) {
      (allData5 || []).forEach((obj) => {
        if (!selectedSchedulesCopy.find(abc => abc.id === obj.id)) {
          selectedSchedulesCopy.push(obj);
        }
      })
    } else {
      selectedSchedulesCopy = [];
    }
    this.setState({ selectedArray5: selectedSchedulesCopy });
  }

  selectAllScheduleRecords6 = () => {
    const { allData6 } = this.state;
    const { selectedArray6 } = this.state
    let selectedSchedulesCopy = [...selectedArray6]
    const value = (selectedSchedulesCopy.length !== allData6.length);

    if (value) {
      (allData6 || []).forEach((obj) => {
        if (!selectedSchedulesCopy.find(abc => abc.id === obj.id)) {
          selectedSchedulesCopy.push(obj);
        }
      })
    } else {
      selectedSchedulesCopy = [];
    }
    this.setState({ selectedArray6: selectedSchedulesCopy });
  }

  selectRouteCode = (index, item) => {
    const { destinationYardFull } = JSON.parse(JSON.stringify(this.state));
    destinationYardFull[index].route_code = item;

    this.setState({
      destinationYardFull
    })

    this.getFromRoutesData(item, index, 'autofill')
  }

  selectFrom = (index, item) => {
    const { destinationYardFull } = JSON.parse(JSON.stringify(this.state));
    destinationYardFull[index].from = item && typeof(item) == 'object' ? null : item;
    const allValuesSelected = destinationYardFull[index].from && destinationYardFull[index].to && destinationYardFull[index].origin_yard && destinationYardFull[index].destination_yard
    this.setState({
      destinationYardFull
    },()=>{
      if(allValuesSelected){
        this.getRouteCodeData(null, index, 'setRouteCode', destinationYardFull[index])
      }
    })
  }

  selectSourceFromTo = (index, sType, item) => {
    const { destinationYardFull, routeDetails } = JSON.parse(JSON.stringify(this.state));
    item = ((routeDetails.source_dest_routes || []).find(el => item.includes(el[sType == 'from'? 'cluster_code' : 'destination'])) || {});
    destinationYardFull[index].from = item && typeof(item) == 'object' ? item.source : item;
    destinationYardFull[index].to = item && typeof(item) == 'object' ? item.destination : item;
    this.setState({
      destinationYardFull
    });
  }

  selectTo = (index, item) => {
    const { destinationYardFull } = JSON.parse(JSON.stringify(this.state));
    destinationYardFull[index].to = item && typeof(item) == 'object' ? null : item;
    const allValuesSelected = destinationYardFull[index].from && destinationYardFull[index].to && destinationYardFull[index].origin_yard && destinationYardFull[index].destination_yard
    this.setState({
      destinationYardFull
    }, () => {
      if (allValuesSelected) {
        this.getRouteCodeData(null, index, 'setRouteCode', destinationYardFull[index])
      }
    })
  }

  selectSingleOriginYard = (index, item) => {
    const { destinationYardFull } = JSON.parse(JSON.stringify(this.state));
    destinationYardFull[index].origin_yard = item && typeof(item) == 'object' ? null : item;
    const allValuesSelected = destinationYardFull[index].from && destinationYardFull[index].to && destinationYardFull[index].origin_yard && destinationYardFull[index].destination_yard
    this.setState({
      destinationYardFull
    }, () => {
      if (allValuesSelected) {
        this.getRouteCodeData(null, index, 'setRouteCode', destinationYardFull[index])
      }
    })
  }

  selectSingleDestinationYard = (index, item) => {
    const { destinationYardFull } = JSON.parse(JSON.stringify(this.state));
    destinationYardFull[index].destination_yard = item && typeof(item) == 'object' ? null : item;
    const allValuesSelected = destinationYardFull[index].from && destinationYardFull[index].to && destinationYardFull[index].origin_yard && destinationYardFull[index].destination_yard
    this.setState({
      destinationYardFull
    }, () => {
      if (allValuesSelected && !isEmami()) {
        this.getRouteCodeData(null, index, 'setRouteCode', destinationYardFull[index])
      }
    })
  }

  selectOriginYard = (index, item) => {
    const { destinationYardFull } = JSON.parse(JSON.stringify(this.state));

    let tempSelectedOriginYard = [...destinationYardFull[index].origin_yard]

    const duplicateVehicle = (tempSelectedOriginYard || []).filter(vehicle => vehicle === item.origin_yard)
    if (!duplicateVehicle || duplicateVehicle.length === 0) {
      if (tempSelectedOriginYard) {
        tempSelectedOriginYard = [...tempSelectedOriginYard, item.origin_yard]
      } else {
        tempSelectedOriginYard = [item.origin_yard]
      }
    }

    destinationYardFull[index].origin_yard = tempSelectedOriginYard

    this.setState({
      destinationYardFull
    });
  }

  deselectOriginYard = (index, item) => {
    const { destinationYardFull } = JSON.parse(JSON.stringify(this.state));

    let tempSelectedOriginYard = [...destinationYardFull[index].origin_yard]

    const updatedOriginYard = tempSelectedOriginYard.filter(vehicle => vehicle !== item.origin_yard)

    tempSelectedOriginYard = [...updatedOriginYard]

    destinationYardFull[index].origin_yard = tempSelectedOriginYard

    this.setState({
      destinationYardFull
    });
  }

  selectDestinationYard = (index, item) => {
    const { destinationYardFull } = JSON.parse(JSON.stringify(this.state));

    let tempSelectedDestinationYard = [...destinationYardFull[index].destination_yard]

    const duplicateDestination = (tempSelectedDestinationYard || []).filter(vehicle => vehicle === item.destination_yard)
    if (!duplicateDestination || duplicateDestination.length === 0) {
      if (tempSelectedDestinationYard) {
        tempSelectedDestinationYard = [...tempSelectedDestinationYard, item.destination_yard]
      } else {
        tempSelectedDestinationYard = [item.destination_yard]
      }
    }

    destinationYardFull[index].destination_yard = tempSelectedDestinationYard

    this.setState({
      destinationYardFull
    });
  }

  deselectDestinationYard = (index, item) => {
    const { destinationYardFull } = JSON.parse(JSON.stringify(this.state));

    let tempSelectedDestinationYard = [...destinationYardFull[index].destination_yard]

    const updatedDestination = tempSelectedDestinationYard.filter(destination => destination !== item.destination_yard)

    tempSelectedDestinationYard = [...updatedDestination]

    destinationYardFull[index].destination_yard = tempSelectedDestinationYard

    this.setState({
      destinationYardFull
    });
  }

  // selectOriginYard = (index, item) => {
  //   const { destinationYardFull } = JSON.parse(JSON.stringify(this.state));
  //   destinationYardFull[index].origin_yard = item;
  //   this.setState({
  //     destinationYardFull
  //   })
  // }

  // selectDestinationYard = (index, item) => {
  //   const { destinationYardFull } = JSON.parse(JSON.stringify(this.state));
  //   destinationYardFull[index].destination_yard = item;
  //   this.setState({
  //     destinationYardFull
  //   })
  // }

  selectRake = (item) => {
    this.setState({
      rakeOf: item
    })
  }

  selectCommodityCat = (item) => {
    this.setState({
      commodity_cato: item
    })
  }

  selectCommodityName = (item) => {
    this.setState({
      commodity_N: item
    })
  }

  selectWagonType = (item) => {
    this.setState({
      WagonType: item
    })
  }

  handleInputChange(event) {
    this.setState({ wagon: event.target.value2 })
  }

  handleInput2Change(event) {
    this.setState({ wagonWt: event.target.value2 })
  }

  handleRefresh = () => {
    close();
    window.location.reload(false);
  }
  handleClose = () => {
    this.setState({
      show: false
    })
    close();
  }

  pageChange = () => {
    this.props.history.location('/singleCostEstimation');
  }

  sendState = () => {
    this.setState({ data: this.state.selectedArray })
  }

  getRowHeading = (key) => {
    return ROW_HEADINGS[key]
  }
  Handlechange = e => {
    this.setState({ show: !this.state.show });
  }

  generatePlan = (close) => {
    const { routeData, destinationYardFull, startDate, endDate,selectedSubPlants } = JSON.parse(JSON.stringify(this.state));
    const { dispatch, selectedNavBranch } = this.props;

    let tempData = [...destinationYardFull]

    tempData.forEach((fullData) => {
      if (fullData.origin_yard) {
        fullData.origin_yard = [`${fullData.origin_yard}`];
      }
      if (fullData.destination_yard) {
        fullData.destination_yard = [`${fullData.destination_yard}`];
      }
    })

    let transport_legs = [];
    routeData.map((ele, idx) => {
      const objValues = Object.values(ele)[0];

      let dataWithType = Object.values(objValues).map((x, idx) => {return {[Object.keys(objValues)[idx]]: x.filter(y => !!y.is_selected)}})

      const selectedData = dataWithType.reduce((result, item) => {
        var key = Object.keys(item)[0]
        if(key){
          result[key] = item[key];
        }
        return result;
      }, {});

      let details = [];

      details.push(selectedData);
      let route_code = [];
      (destinationYardFull || []).forEach(el => {
        if([...el.origin_yard, ...el.destination_yard].includes(Object.keys(ele)[0])) {
          route_code.push(el.route_code);
        }
      });
      transport_legs.push({ details: details, leg_no: idx + 1, location: Object.keys(ele)[0], route_code })
    })

    const user = getUser();
    const subplant_name = selectedSubPlants.filter((ele)=>ele.isSelected)
 
    if(!isEmami() && !isCoromandel() && subplant_name.length<=0){
      dispatch({
        type: TOAST_ERROR,
        message: "Please select at least one sub plant"
    })
    return
    }
    const payload = {
      company_id: user.id,
      branch_id: (selectedNavBranch || {}).branch_id || user.branchId || '1212',
      contract_tenure_from: new Date(moment(startDate)).setHours(0, 0, 0, 0),
      contract_tenure_to: new Date(moment(endDate)).setHours(23, 59, 59),
      route_code: tempData[0].route_code,
      route_codes: (destinationYardFull || []).map(el => el.route_code),
      from: tempData[0].from,
      to: tempData[0].to,
      origin_yard: tempData.map(d => {
        if (d.origin_yard && d.origin_yard.length) {
          return d.origin_yard[0]
        }
      }),
      destination_yard: tempData.map(d => {
        if (d.destination_yard && d.destination_yard.length) {
          return d.destination_yard[0]
        }
      }),
      transport_legs: transport_legs,
      subplant_name
    }

    dispatch({ type: START_LOADER });
    dispatch({
      type: GENERATE_PLAN_IN_MASTER_CONTRACT,
      data: payload,
      onSuccess: (() => {
        dispatch({ type: END_LOADER });
        close()
      }),
      onError: () => dispatch({ type: END_LOADER })
    })
  }

  checkGenerateContractButton = (routeData) => {

    let isEnabled = false;

    routeData.forEach((ele) => {
      const heading = Object.keys(ele)[0];

      Object.keys(ele[heading]).forEach((subEle) => {
        const data = ele[heading][subEle]

        data && data.length && data.forEach((val) => {
          if (val.is_selected) {
            isEnabled = true
          }
        })

      })
    })

    return isEnabled;
  }

  checkAllSelected = (type, routeData) => {

    let isEnabled = true;

    let dataWithType = Object.values(routeData).map(x => x.filter(y => y.order_text == type))

    let checkAllDatasEmpty = dataWithType.find(xx=> xx.length !== 0)

    if (!checkAllDatasEmpty){
      isEnabled = false
    }else {
      dataWithType.forEach((ele) => {
  
        ele && ele.length && ele.forEach((val) => {
          if (!val.is_selected) {
            isEnabled = false
          }
        })
  
        const selectedDatas = ele.filter((val) => (val.is_selected == true));
  
          if (selectedDatas.length !== ele.length) {
            isEnabled = false
          }
      })
    }


    return isEnabled;

  }

  selectAll = (type, routeData, requiredProviderData, provider) => {
    let tempRouteData = routeData;

    let isAllSelected = true;

    let dataWithType = Object.values(requiredProviderData).map(x => x.filter(y => y.order_text == type))

    dataWithType.forEach((ele) => {

      ele && ele.length && ele.forEach((val) => {
        if (!val.is_selected) {
          isAllSelected = false
        }
      })

      const selectedDatas = ele.filter((val) => (val.is_selected == true));

      if (selectedDatas.length !== ele.length) {
        isAllSelected = false
      }
    })

    if (isAllSelected === true) {

      tempRouteData.forEach((ele) => {
        const heading = Object.keys(ele)[0];

        Object.keys(ele[heading]).forEach((subEle) => {
          const data = ele[heading][subEle]

          data && data.length && data.forEach((val) => {
            if ((val.order_text == type) && (provider == heading)) {
              val.is_selected = false
            }
          })
        })
      })

    } else {

      tempRouteData.forEach((ele) => {
        const heading = Object.keys(ele)[0];

        Object.keys(ele[heading]).forEach((subEle) => {
          const data = ele[heading][subEle]

          data && data.length && data.forEach((val) => {
            if ((val.order_text == type) && (provider == heading)) {
              val.is_selected = true
            }
          })
        })
      })

    }

    this.setState({
      routeData: tempRouteData
    })

  }


 handleSelectAllSubPlant = ()=>{
  const { selectedSubPlants } = this.state;
  let updateSelectedSubPlants = []
  const isAllSelected = selectedSubPlants.every((ele)=>ele.isSelected)
  if(isAllSelected){
    updateSelectedSubPlants = selectedSubPlants.map((ele)=>{
      return {
        ...ele,
        isSelected:false
      }
    })
  }else{
    updateSelectedSubPlants = selectedSubPlants.map((ele)=>{
      return {
        ...ele,
        isSelected:true
      }
    })
  }
  this.setState({selectedSubPlants: updateSelectedSubPlants})
 }

 handleSelectSubPlant = (indexOfSP)=>{
  const { selectedSubPlants } = this.state;
  let updateSelectedSubPlants = updateSelectedSubPlants = selectedSubPlants.map((ele,ind)=>{
   if(indexOfSP === ind){
    return {
      ...ele,
      isSelected:!ele.isSelected
    }
   }else{
    return ele
   }
  })
  this.setState({selectedSubPlants: updateSelectedSubPlants})
 }

 searchRouteValidation = () => {
  let enable = true;
  (this.state.destinationYardFull || []).forEach(dest => {
    if((isEmami() ? true : dest.route_code) && dest.from && dest.origin_yard && dest.to && dest.destination_yard && this.state.startDate && this.state.endDate){
      enable = false;
    }
    else enable = true;
  })
  return enable
 }


 getSourceRoutes = () => {
  let source = [];
  const { routeDetails } = this.state;
  source = (routeDetails.source_dest_routes || []).map(el => {
    return {
      ...el,
      sourceClusterCode: `${el.source} (${el.cluster_code})`
    }
  })
  return source;
 }

 selectClusterCode = (index, sType, item) => {
    const { destinationYardFull, routeDetails } = JSON.parse(JSON.stringify(this.state));
    item = ((routeDetails.source_dest_routes || []).find(el => item.includes(el[sType == 'from'? 'cluster_code' : 'destination'])) || {});
    destinationYardFull[index].from = item && typeof(item) == 'object' ? item.source : item;
    destinationYardFull[index].to = item && typeof(item) == 'object' ? item.destination : item;
    destinationYardFull[index].route_code = item && typeof(item) == 'object' ? item.cluster_code : item;
    this.setState({
      destinationYardFull
    });
  }

  renderTransporterNameOrAggregator = (info) =>{
    if(isCoromandel()){
      return (info.aggregator_name || info.transporter_name)
    }
    return info.transporter_name
  }

  render() {
    const { fromRoutes, searchRoutesContract ,allSubPlants, loader} = this.props

    const { routecodeData, routeData, destinationYardFull, locationDropdownValues,selectedSubPlants, routeDetails } = this.state;
  

    const contentStyle = {
      width: "90%",
      height: "auto",
      maxHeight: "80%",
      // overflowY: "scroll",
      background: "none",
      border: "none"
    }

    let total = parseInt(this.state.selectedArray.map((a) => a.Rate) + this.state.selectedArray.map((a) => a.Rate2) + this.state.selectedArray.map((a) => a.Rate3));

    const temp = [{ id: 1, label: "123456" }, { id: 2, label: "123457" }, { id: 3, label: "123458" }, { id: 4, label: "123459" }, { id: 5, label: "123460" }];

    const From = [{ id: 1, label: "Surat" }, { id: 2, label: "Bharuch" }, { id: 3, label: "Vadodara" }, { id: 4, label: "Anand" }, { id: 5, label: "Ahmedabad" }];

    const To = [{ id: 1, label: "Surat" }, { id: 2, label: "Bharuch" }, { id: 3, label: "Vadodara" }, { id: 4, label: "Anand" }, { id: 5, label: "Ahmedabad" }];

    const origin_yard = [{ id: 1, label: "Teeka" }, { id: 2, label: "Silva" }, { id: 3, label: "Namor" }, { id: 4, label: "Waild" }, { id: 5, label: "Anna" }];

    const destination_yard = [{ id: 1, label: "Sunar" }, { id: 2, label: "Aqua" }, { id: 3, label: "Dilon" }, { id: 4, label: "Max" }, { id: 5, label: "Vidar" }];

    const Rake = [{ id: 1, label: "Empty" }, { id: 2, label: "Half" }, { id: 3, label: "Full" }];

    const Commodity_cat = [{ id: 1, label: "Fual" }, { id: 2, label: "Oil" }, { id: 3, label: "Sugar" }, { id: 4, label: "Salt" }, { id: 5, label: "Milk" }];

    const Commodity_name = [{ id: 1, label: "Refined" }, { id: 2, label: "Non-Refined" }, { id: 3, label: "All Refined" }, { id: 4, label: "All Non-Refined" }, { id: 5, label: "All Refined and Non-Refined" }];

    const Wagon_type = [{ id: 1, label: "Open Wagon" }, { id: 2, label: "Covered-Wagon" }, { id: 3, label: "Tank Wagon" }, { id: 4, label: "Flat Wagon" }, { id: 5, label: "Brake van" }];
    return (

      <Sticky>
        {loader && <ActionLoader fixed={true} />}
        <div className="main-div" style={{ maxWidth: "2000px" }}>
          <ScreenTimeTrack
            screenInfoDetailsItem={
              screenInfoDetails.CREATE_NEW_CONTRACTS_SCREEN
            }
          />
          <div className="arrow-text" style={{ cursor: "pointer" }} onClick={() => {
            this.props.history.goBack()
          }}>
            <div>
              <Back className="fill-theme mr-5" />
            </div>
            <div className="header-text">
              Create New Contract
            </div>
          </div>

          <div className="back-light-blue">

            {this.state.destinationYardFull.map((ele, idx) => (
              <div className="input-fields">
                {isEmami() ? <div className="input-field fs-14 header-dark-color pl-20 pr-20">
                  <div style={{ paddingBottom: "5px", color: "black", fontWeight: "700" }} key={idx}>
                    {'Cluster Code'}
                  </div>
                  <Dropdown
                    items={routecodeData && routecodeData.length && routecodeData[idx] || []}
                    label={'Cluster Code'}
                    displayKey="cluster_code"
                    canClear
                    onSelect={this.selectClusterCode.bind(this, idx, 'from')}
                    onSearchText={(text)=>{this.getRouteCodeData(text,idx)}}
                    className="mb-0 wt-250 ht-30"
                    searchEnabled={true}
                    selectedItem={!!this.state.routecodeData && !!this.state.routecodeData.length && this.state.routecodeData[idx] && !!this.state.routecodeData[idx].length && this.state.routecodeData[idx].find((sub) => ele.route_code == sub.cluster_code)}
                  /> 
                </div> :  
                <div className="input-field fs-14 header-dark-color pl-20 pr-20">
                  <div style={{ paddingBottom: "5px", color: "black", fontWeight: "700" }} key={idx}>
                    {'Route Code'}
                  </div>
                  <Dropdown
                    items={routecodeData && routecodeData.length && routecodeData[idx] || []}
                    label={'Route Code'}
                    displayKey={isCoromandel() ? "sap_code" : "route_code"}
                    canClear
                    onSelect={this.selectRouteCode.bind(this, idx)}
                    onSearchText={(text)=>{this.getRouteCodeData(text,idx)}}
                    className="mb-0 wt-250 ht-30"
                    searchEnabled={true}
                    selectedItem={!!this.state.routecodeData && !!this.state.routecodeData.length && this.state.routecodeData[idx] && !!this.state.routecodeData[idx].length && this.state.routecodeData[idx].find((sub) => ele.route_code == sub.sap_code)}
                  /> </div>}
                {/* <hr height="20px" width="1px" size="100" color="#468ce2" /> */}
                <div className="input-field fs-14 header-dark-color pl-20 pr-20">
                  <div style={{ paddingBottom: "5px", color: "black", fontWeight: "700" }} key={idx}>
                    {'From'}
                  </div>
                  {isEmami() ? 
                    <Dropdown 
                      items={this.getSourceRoutes() || []}
                      label={'From'}
                      displayKey="source"
                      canClear
                      onSelect={this.selectSourceFromTo.bind(this, idx, 'from')}
                      // onSearchText={(text) => { this.getLocationValues(text, idx, 'source', 1) }}
                      className="mb-0 wt-250 ht-30"
                      searchEnabled={true}
                      selectedItem={(this.getSourceRoutes()|| []).find((sub) => (ele.from == sub.source) && (ele.route_code == sub.cluster_code))}
                    />
                  : <Dropdown
                    items={locationDropdownValues[idx].fromArray || []}
                    label={'From'}
                    displayKey="source"
                    canClear
                    onSelect={this.selectFrom.bind(this, idx)}
                    onSearchText={(text) => { this.getLocationValues(text, idx, 'source', 1) }}
                    className="mb-0 wt-250 ht-30"
                    searchEnabled={true}
                    selectedItem={(locationDropdownValues[idx].fromArray || []).find((sub) => ele.from == sub.source)}
                  />}
                </div>
                <hr width="1px" size="100" color="#468ce2" />
                <div className="input-field fs-14 header-dark-color pl-20 pr-20">
                  <div style={{ paddingBottom: "5px", color: "black", fontWeight: "700" }} key={idx}>
                    {'Origin Yard'}
                  </div>

                  <div className="d-flex-column gap-10">
                    <div className="d-flex gap-10">
                      {isEmami() ? 
                      <Dropdown
                        items={(routeDetails || {}).origin_destination_yard || []}
                        label={'Origin Yard'}
                        displayKey="origin_yard"
                        canClear
                        onSelect={this.selectSingleOriginYard.bind(this, idx)}
                        onSearchText={(text) => { this.getLocationValues(text, idx, 'origin_yard', 3) }}
                        // className="mb-0 wt-250 ht-30"
                        searchEnabled={true}
                        selectedItem={((routeDetails || {}).origin_destination_yard || []).find((sub) => ele.origin_yard == sub.origin_yard)}
                      /> : 
                      <Dropdown
                        items={locationDropdownValues[idx].originYardArray || []}
                        label={'Origin Yard'}
                        displayKey="origin_yard"
                        canClear
                        onSelect={this.selectSingleOriginYard.bind(this, idx)}
                        onSearchText={(text) => { this.getLocationValues(text, idx, 'origin_yard', 3) }}
                        // className="mb-0 wt-250 ht-30"
                        searchEnabled={true}
                        selectedItem={(locationDropdownValues[idx].originYardArray || []).find((sub) => ele.origin_yard == sub.origin_yard)}
                      />}
                      {/* <MultipleDropdown
                        items={this.state.originYardArray}
                        selectedItems={ele.origin_yard && ele.origin_yard.map((item, ind) => { return { origin_yard: item, value: item } })}
                        deselect={(item) => this.deselectOriginYard(idx, item)}
                        name="Origin Yard"
                        onSelect={(item) => this.selectOriginYard(idx, item)}
                        displayKey="origin_yard"
                        className="br-5 wt-auto fs-12 bg-white"
                        isMinHeight={true}
                        label="Origin Yard"
                        isMinWidth
                      /> */}
                      {/* <div className="plus-btn" onClick={this.addOriginYard}>
                      <BsPlusSquareFill />
                    </div> */}
                    </div>

                    {/* {this.state.multipleOriginYard.map((a, idx) => (
                    idx ? <div className="d-flex gap-10">
                      <Dropdown
                        items={routecodeData}
                        label={a.originYard}
                        displayKey="origin_yard"
                        selectedItem={null}
                        onSelect={() => this.selectOriginYard()}
                        // className="mb-0 wt-250 ht-30"
                        searchEnabled={true}
                      />
                      <div className="plus-btn" onClick={this.addOriginYard}>
                        <BsPlusSquareFill />
                      </div>
                      <div className="cross-delete">
                        <TiDelete  onClick={() => this.removeOriginYard(idx)}/>
                      </div>
                    </div> : null))} */}

                  </div>

                </div>
                <hr width="1" size="100" color="#468ce2" />
                    <div className=" input-field fs-14 header-dark-color pl-20 pr-20">
                      <div style={{ paddingBottom: "5px", color: "black", fontWeight: "700" }} key={idx}>
                        {'To'}
                      </div>
                      {isEmami() ? 
                    <Dropdown 
                      items={this.getSourceRoutes() || []}
                      label={'To'}
                      displayKey="destination"
                      canClear
                      onSelect={this.selectSourceFromTo.bind(this, idx, 'to')}
                      // onSearchText={(text) => { this.getLocationValuesgetLocationValues(text, idx, 'source', 1) }}
                      className="mb-0 wt-250 ht-30"
                      searchEnabled={true}
                      selectedItem={(this.getSourceRoutes()|| []).find((sub) => ele.to == sub.destination)}
                    /> :
                      <Dropdown
                        items={locationDropdownValues[idx].toArray || []}
                        label={'To'}
                        displayKey="destination"
                        canClear
                        onSelect={this.selectTo.bind(this, idx)}
                        onSearchText={(text) => { this.getLocationValues(text, idx, 'destination', 2) }}
                        className="mb-0 wt-250 ht-30"
                        searchEnabled={true}
                        selectedItem={(locationDropdownValues[idx].toArray || []).find((sub) => ele.to == sub.destination)}
                      />}
                    </div>
                    <hr width="1px" size="100" color="#468ce2" />
                    <div className="  input-field fs-14 header-dark-color pl-20 pr-20">
                      <div style={{ paddingBottom: "5px", color: "black", fontWeight: "700" }} key={idx}>
                        {'Destination Yard'}
                      </div>
                      <div className="d-flex-column gap-10">
                        <div className="d-flex gap-10">
                          {isEmami() ? 
                          <Dropdown
                          items={(routeDetails || {}).origin_destination_yard || []}
                          label={'Destination Yard'}
                          displayKey="destination_yard"
                          canClear
                          selectedItem={((routeDetails || {}).origin_destination_yard || []).find((sub) => ele.destination_yard == sub.destination_yard)}
                          onSelect={this.selectSingleDestinationYard.bind(this, idx)}
                          onSearchText={(text) => { this.getLocationValues(text, idx, 'destination_yard', 4) }}
                          // className="mb-0 wt-250 ht-30"
                          searchEnabled={true}
                        /> :
                          <Dropdown
                            items={locationDropdownValues[idx].destinationYardArray || []}
                            label={'Destination Yard'}
                            displayKey="destination_yard"
                            canClear
                            selectedItem={(locationDropdownValues[idx].destinationYardArray || []).find((sub) => ele.destination_yard == sub.destination_yard)}
                            onSelect={this.selectSingleDestinationYard.bind(this, idx)}
                            onSearchText={(text) => { this.getLocationValues(text, idx, 'destination_yard', 4) }}
                            // className="mb-0 wt-250 ht-30"
                            searchEnabled={true}
                          />}

                          {/* <MultipleDropdown
                            items={this.state.destinationYardArray}
                            selectedItems={ele.destination_yard && ele.destination_yard.map((item, ind) => { return { destination_yard: item, value: item } })}
                            deselect={(item) => this.deselectDestinationYard(idx, item)}
                            name="Destination Yard"
                            onSelect={(item) => this.selectDestinationYard(idx, item)}
                            displayKey="destination_yard"
                            className="br-5 wt-auto fs-12 bg-white"
                            isMinHeight={true}
                            label="Destination Yard"
                          /> */}
                          {/* <div className="plus-btn" onClick={() => this.addDestinationYard()} >
                            <BsPlusSquareFill />
                          </div> */}
                        </div>
                        {/* {this.state.multipleDestinationYard.map((a, idx) => (
                          idx ? <div className="d-flex gap-10">
                            <Dropdown
                              items={routecodeData}
                              label={a.destinationYard}
                              displayKey="destination_yard"
                              selectedItem={null}
                              onSelect={this.selectDestinationYard}
                              // className="mb-0 wt-250 ht-30"
                              searchEnabled={true}
                            />
                            <div className="plus-btn" onClick={this.addDestinationYard}>
                              <BsPlusSquareFill />
                            </div>
                            <div className="cross-delete">
                              <TiDelete  onClick={() => this.removeDestinationYard(idx)}/>
                            </div>
                          </div> : null)
                          )} */}
                      </div>

                    </div>
                    <hr width="1px" size="100" color="#468ce2" className="mr-10" />
                    <div >

                      <div className="fs-14 header-dark-color mr-10 cursor-pointer" style={{ display: "flex", alignItems: "center", justifyContent: 'center', paddingTop: "35px", gap: "5px" }}>
                        <br></br>
                        <br></br>
                        {idx ? <AiOutlineCloseCircle style={{ width: "35px", height: "35px", color: "grey", cursor: "pointer" }} onClick={() => this.removeDestionationYard(idx)} /> : <div style={{ width: "35px", height: "35px", color: "grey", cursor: "pointer" }} />}
                      </div>
                    </div>

              </div>
            ))}



            {!isEmami() && <Fragment>
              <div className="fBold fs-18 mb-20 header-medium-color">
                <div className="fBold fs-18 mb-10 header-medium-color">
                  Sub-Plants 
                  {!isCoromandel() && <sup className="danger-color pr t-4">*</sup>}
                  {/* {submitted && allSubPlants.length > 0 && selectedSubPlants.length === 0 && <div className="error-color fs-14 fSemibold op-7 ml-5 mt-5">Please Select Sub-Plants </div>} */}
                </div>
                {
                  ((allSubPlants || []).length > 0) && <div className="pr-10 pl-10 curP flex mb-10">
                    <Checkbox
                      onCheck={() => this.handleSelectAllSubPlant()}
                      checked={selectedSubPlants.every((ele)=>ele.isSelected)}
                    /> All</div>
                }
                <div className="flex wt-650 flex-wrap">
                  {
                    (selectedSubPlants || []).map((subplant, indexOfSP) => {
                      return (
                        <div className="pr-10 pl-10 curP flex flex-middle mb-10">
                          <Checkbox
                            onCheck={() => this.handleSelectSubPlant(indexOfSP)}
                            // checked={selectedSubPlants.includes(subplant.plant)} />
                            checked={subplant.isSelected} 
                            />
                          {subplant.plant || ''}
                        </div>
                      )
                    })
                  }
                </div>
              </div>
            </Fragment>}

            <div className="flex wt-100p flex-between">
              <button className="anther-route-code" style={{ marginRight: '30px' }} onClick={() => this.addNewRouteCode()}>
                + Add Another Route Code
              </button>

              <div className="flex flex-column" style={{marginRight:'15px'}}>
                <span className="fBold mb-5">Contract Tenure</span>
                <DateRangePicker
                  displayFormat='DD/MM/YYYY'
                  startDate={(this.state.startDate)} // momentPropTypes.momentObj or null,
                  startDateId="start" // PropTypes.string.isRequired,
                  endDate={this.state.endDate} // momentPropTypes.momentObj or null,
                  endDateId="end" // PropTypes.string.isRequired,
                  isOutsideRange={() => null}
                  onDatesChange={({ startDate, endDate }) => {
                    this.setState({ startDate: startDate, endDate: endDate })
                  }}
                  focusedInput={this.state.focusedInput} // PropTypes.oneOf([START_DATE, END_DATE]) or null,
                  onFocusChange={focusedInput => this.setState({ focusedInput })} // PropTypes.func.isRequired,
                />
              </div>

            </div>

            <hr width="98%" />


            {/* ADD FULL ROW ON PLUS BUTTON */}

            <div style={{ display: "flex", justifyContent: "end", padding: "5px 35px 15px 0px", cursor: "pointer" }}>
              <div 
              onClick={this.searchRoutesMasterContract} 
              style={{ display: "flex", justifyContent: "center", paddingRight: "20px", border: "1px solid #528aea", width: "320px", alignItems: "center", padding: "8px 20px", backgroundColor: "#528aea", fontWeight: "700", color: "white", borderRadius: "5px" }}
              className={classNames('', {'notselectable': this.searchRouteValidation()})}>
                Search Route</div>
            </div>
          </div>

          {/* <table style={{ boxShadow: 'rgba(136, 165, 300, 0.6) 0px 0px 5px 0px, rgba(255, 255, 255, 0.7) 0px 0px 5px 0px', width: "100%", borderSpacing: '0px', marginTop: "30px" }
          }>
            <thead className="ht-40 fs-14 fBold curP table-bg-blue white-color">
              <tr className="br-10">

                <th className=''>
                  <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                    <div style={{ paddingLeft: "5px" }}>
                      <svg xmlns="http://www.w3.org/2000/svg" width="15" height="18" viewBox="0 0 15 21">
                        <g fill="none" fill-rule="nonzero">
                          <path fill="#9FA8DA" d="M7.5 0C3.364 0 0 3.412 0 7.605 0 12.81 6.712 20.45 6.998 20.773a.67.67 0 0 0 1.004 0C8.288 20.45 15 12.81 15 7.605 15 3.412 11.635 0 7.5 0zm0 19.266c-2.259-2.72-6.15-8.089-6.15-11.66 0-3.44 2.76-6.236 6.15-6.236 3.39 0 6.15 2.797 6.15 6.235 0 3.572-3.89 8.94-6.15 11.661z" />
                          <path fill="#FFF" d="M7.5 19.266c-2.259-2.72-6.15-8.089-6.15-11.66 0-3.44 2.76-6.236 6.15-6.236 3.39 0 6.15 2.797 6.15 6.235 0 3.572-3.89 8.94-6.15 11.661z" />
                          <path fill="#9FA8DA" d="M7.5 3.23c-2.394 0-4.342 1.994-4.342 4.443 0 2.45 1.948 4.442 4.342 4.442 2.394 0 4.342-1.992 4.342-4.442S9.894 3.231 7.5 3.231zm0 7.108c-1.524 0-2.763-1.195-2.763-2.665S5.977 5.008 7.5 5.008c1.524 0 2.763 1.195 2.763 2.665s-1.24 2.665-2.763 2.665z" />
                        </g>
                      </svg>
                    </div>
                    <span>
                      {this.state.originYard}
                    </span>
                  </div>
                </th>

                <th className='col-4 tLeft'><Checkbox type="square" label="L1" checked={this.state.selectedArray.length === this.state.allData.length} onCheck={() => { this.selectAllScheduleRecords() }} /></th>
                <th className='col-4 tLeft'><Checkbox type="square" label="L2" checked={this.state.selectedArray2.length === this.state.allData2.length} onCheck={() => { this.selectAllScheduleRecords2() }} /></th>
                <th className='col-4 tLeft'><Checkbox type="square" label="L3" checked={this.state.selectedArray3.length === this.state.allData3.length} onCheck={() => { this.selectAllScheduleRecords3() }} /></th>
              </tr>
            </thead>


            <tbody className="ht-40 fs-14 fBold mr-5 mt-10 curP label-color">
              {this.state.allData.map((ele, idx) => {
                return (
                  <tr key={idx} >

                    <td className="tLeft p-5 pl-10  master-contract-font-color last-chil      v dddd" style={{ borderBottom: "1px solid black" }}>
                      {ele.name}
                    </td>

                    <td style={{ paddingTop: "20px", borderBottom: "1px solid black" }}>
                      <div>
                        <th className='col-4 tLeft' key={idx}>
                          <Checkbox type="square" label={ele.check1} onCheck={() => { this.checkedFullRow(ele) }} checked={this.state.selectedArray.find(obj => obj.id === ele.id)} /></th>
                      </div>
                      <span style={{ paddingTop: "10px", paddingLeft: "20px", display: "flex", gap: "20px", alignItems: "center" }}>
                        <storng>Rate:</storng>   {ele.Rate} Per MT
                        <span style={{ background: "green", color: "white", padding: "5px", borderRadius: "99px" }}>L1</span>
                      </span>

                      <div style={{ display: "flex", paddingLeft: "20px", paddingTop: "10px", gap: "20px" }}>
                        <div style={{ fontSize: "12px", fontWeight: "800" }}>
                          SAP Contract No:
                          <div style={{ fontWeight: "normal", paddingTop: "8px", paddingBottom: "10px" }}>{ele.Contract_No}</div>
                        </div>
                        <div style={{ fontSize: "12px", fontWeight: "800" }}> Contract Tenure:
                          <div style={{ fontWeight: "normal", paddingTop: "8px" }}>{ele.date}</div>
                        </div>
                      </div>
                    </td>

                    <td style={{ color: "rgb(164, 164, 164)", borderBottom: "1px solid black" }}>
                      <div style={{ paddingBottom: "10px" }}>
                        <th className='col-4 tLeft'><Checkbox type="square" label={ele.check2} onCheck={() => { this.checkedFullRow2(ele) }} checked={this.state.selectedArray2.find(obj => obj.id === ele.id)} /></th>
                      </div>
                      <span style={{ paddingTop: "10px", paddingLeft: "20px", fontSize: "15px" }}>
                        <storng>Rate:</storng>   {ele.Rate2} Per MT
                        <span style={{ background: "orange", color: "white", padding: "5px", borderRadius: "99px", marginLeft: "5px" }}>L2</span>
                      </span>
                      <div style={{ paddingLeft: "20px", paddingTop: "10px", paddingBottom: "10px" }}>

                        <button style={{ padding: "5px 10px", background: "#528aea", color: "white", borderRadius: "5px" }}>
                          send LOI
                        </button>
                      </div>
                      <div></div>
                    </td>

                    <td style={{ color: "rgb(164, 164, 164)", borderBottom: "1px solid black" }}>
                      <div style={{ paddingBottom: "10px" }}>
                        <th className='col-4 tLeft'><Checkbox type="square" label={ele.check3} onCheck={() => { this.checkedFullRow3(ele) }} checked={this.state.selectedArray3.find(obj => obj.id === ele.id)} /></th>
                      </div>
                      <span style={{ paddingTop: "10px", paddingLeft: "20px", fontSize: "15px" }}>
                        <storng>Rate:</storng>   {ele.Rate3} Per MT
                        <span style={{ background: "orange", color: "white", padding: "5px", borderRadius: "99px", marginLeft: "5px" }}>L3</span>
                      </span>
                      <div style={{ paddingLeft: "20px", paddingTop: "10px", paddingBottom: "10px" }}>

                        <button style={{ padding: "5px 10px", background: "#528aea", color: "white", borderRadius: "5px" }}>
                          send LOI
                        </button>
                      </div>
                      <div></div>
                    </td>

                  </tr>
                )
              })}

            </tbody>

          </table > */}


          {
            !!routeData && !!routeData.length && routeData.map((ele, idx) => {
              const heading = Object.keys(ele)[0];
              return (
                <table style={{ boxShadow: 'rgba(136, 165, 300, 0.6) 0px 0px 5px 0px, rgba(255, 255, 255, 0.7) 0px 0px 5px 0px', width: "100%", borderSpacing: '0px', marginTop: "30px", borderCollapse: 'collapse' }}>
                  <thead className="ht-40 fs-14 fBold mr-5 mt-10 curP table-bg-blue white-color">
                    <tr className="br-10">
                      <th className=''>
                        <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                          <div style={{ paddingLeft: "5px" }}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="15" height="18" viewBox="0 0 15 21">
                              <g fill="none" fill-rule="nonzero">
                                <path fill="#9FA8DA" d="M7.5 0C3.364 0 0 3.412 0 7.605 0 12.81 6.712 20.45 6.998 20.773a.67.67 0 0 0 1.004 0C8.288 20.45 15 12.81 15 7.605 15 3.412 11.635 0 7.5 0zm0 19.266c-2.259-2.72-6.15-8.089-6.15-11.66 0-3.44 2.76-6.236 6.15-6.236 3.39 0 6.15 2.797 6.15 6.235 0 3.572-3.89 8.94-6.15 11.661z" />
                                <path fill="#FFF" d="M7.5 19.266c-2.259-2.72-6.15-8.089-6.15-11.66 0-3.44 2.76-6.236 6.15-6.236 3.39 0 6.15 2.797 6.15 6.235 0 3.572-3.89 8.94-6.15 11.661z" />
                                <path fill="#9FA8DA" d="M7.5 3.23c-2.394 0-4.342 1.994-4.342 4.443 0 2.45 1.948 4.442 4.342 4.442 2.394 0 4.342-1.992 4.342-4.442S9.894 3.231 7.5 3.231zm0 7.108c-1.524 0-2.763-1.195-2.763-2.665S5.977 5.008 7.5 5.008c1.524 0 2.763 1.195 2.763 2.665s-1.24 2.665-2.763 2.665z" />
                              </g>
                            </svg>
                          </div>
                          <span>{heading}</span>
                        </div></th>

                      <th className='col-4 tLeft'><Checkbox type="square" label="L1" checked={this.checkAllSelected('L1', ele[heading])} onCheck={() => { this.selectAll('L1', routeData, ele[heading], heading) }} /></th>
                      <th className='col-4 tLeft'><Checkbox type="square" label="L2" checked={this.checkAllSelected('L2', ele[heading])} onCheck={() => { this.selectAll('L2', routeData, ele[heading], heading) }} /></th>
                      <th className='col-4 tLeft'><Checkbox type="square" label="L3" checked={this.checkAllSelected('L3', ele[heading])} onCheck={() => { this.selectAll('L3', routeData, ele[heading], heading) }} /></th>

                      {/* <th className='col-4 tLeft' onCheck={() => { this.selectAllScheduleRecords() }}>L1</th>
                      <th className='col-4 tLeft' onCheck={() => { this.selectAllScheduleRecords2() }}>L2</th>
                      <th className='col-4 tLeft' onCheck={() => { this.selectAllScheduleRecords3() }}>L3</th> */}
                    </tr>
                  </thead>


                  <tbody className="ht-40 fs-14 fBold mr-5 mt-10 curP label-color">
                    {/* FIRST TABLE */}

                    {
                      Object.keys(ele[heading]).map((subEle, sIndex) => {

                        const data = ele[heading][subEle]

                        if (data && data.length) {
                          return (
                            <tr key={sIndex} style={{ borderBottom: '1px solid black' }} >
                              <td className="tLeft p-5 pl-10  master-contract-font-color last-child">
                                {this.getRowHeading(subEle) || '-'}
                              </td>

                              {
                                ['L1', 'L2', 'L3'].map((type) => {
                                  return (
                                    <td style={{ padding: "20px 0px" }}>
                                      {data.map((info, dIndex) => {
                                        return (
                                          <>
                                            {(type == info.order_text) && <div style={{ paddingBottom: `${(data.length > (dIndex + 1)) ? '20px' : '0px'}` }}>
                                              <div style={{width:'500px'}}>
                                                <th className='tLeft' key={idx}>
                                                  <Checkbox type="square" label={this.renderTransporterNameOrAggregator(info)} onCheck={() => { this.checkSingleElement(idx, heading, subEle, dIndex) }} checked={info.is_selected ? true : false} /></th>
                                              </div>
                                              <span style={{ paddingTop: "10px", paddingLeft: "20px", display: "flex", gap: "10px", alignItems: "center" }}>
                                                <storng>Rate:</storng>  {info.price} Per MT
                                                <span style={{ background: "green", color: "white", padding: "5px", borderRadius: "99px" }}>{info.order_text}</span>
                                              </span>

                                              <div style={{ display: "flex", paddingLeft: "20px", paddingTop: "10px", gap: "20px" }}>
                                                <div style={{ fontSize: "12px", fontWeight: "800" }}> Contract Tenure:
                                                  <div style={{ fontWeight: "normal", paddingTop: "8px" }}>{moment(info.contract_tenure_from).format('DD-MM-YYYY')} To {moment(info.contract_tenure_to).format('DD-MM-YYYY')}</div>
                                                </div>
                                              </div>
                                            </div>}


                                            {ele.check2 && ele.Rate2 &&
                                              <td style={{ color: "rgb(164, 164, 164)", borderBottom: "1px solid black" }}>
                                                <div style={{ paddingBottom: "10px" }}>
                                                  <th className='col-4 tLeft'><Checkbox type="square" label={ele.check2} onCheck={() => { this.checkedFullRow2(ele) }} checked={this.state.selectedArray2.find(obj => obj.id === ele.id)} /></th>
                                                </div>
                                                <span style={{ paddingTop: "10px", paddingLeft: "20px", fontSize: "15px" }}>
                                                  <storng>Rate:</storng>   {ele.Rate2} Per MT
                                                  <span style={{ background: "orange", color: "white", padding: "5px", borderRadius: "99px", marginLeft: "5px" }}>L2</span>
                                                </span>
                                                <div style={{ paddingLeft: "20px", paddingTop: "10px", paddingBottom: "10px" }}>

                                                  <button style={{ padding: "5px 10px", background: "#528aea", color: "white", borderRadius: "5px" }}>
                                                    send LOI
                                                  </button>
                                                </div>
                                                <div></div>
                                              </td>}

                                            {ele.check3 && ele.Rate3 &&
                                              <td style={{ color: "rgb(164, 164, 164)", borderBottom: "1px solid black" }}>
                                                <div style={{ paddingBottom: "10px" }}>
                                                  <th className='col-4 tLeft'><Checkbox type="square" label={ele.check3} onCheck={() => { this.checkedFullRow3(ele) }} checked={this.state.selectedArray3.find(obj => obj.id === ele.id)} /></th>
                                                </div>
                                                <span style={{ paddingTop: "10px", paddingLeft: "20px", fontSize: "15px" }}>
                                                  <storng>Rate:</storng>   {ele.Rate3} Per MT
                                                  <span style={{ background: "orange", color: "white", padding: "5px", borderRadius: "99px", marginLeft: "5px" }}>L3</span>
                                                </span>
                                                <div style={{ paddingLeft: "20px", paddingTop: "10px", paddingBottom: "10px" }}>

                                                  <button style={{ padding: "5px 10px", background: "#528aea", color: "white", borderRadius: "5px" }}>
                                                    send LOI
                                                  </button>
                                                </div>
                                                <div></div>
                                              </td>}
                                          </>
                                        )
                                      })
                                      }
                                    </td>
                                  )
                                })
                              }

                            </tr>
                          )

                        }
                      })
                    }
                  </tbody>
                </table>
              )
            })
          }

          <div style={{ display: "flex", alignItems: "center", justifyContent: "end" }}>

            <div style={{ paddingTop: "20px", justifyContent: "end" }}>
              <Popup
                trigger={
                  (<button style={{ border: "1px solid #528aea", color: "#528aea" }}
                    className={" wt-250 pl-15 pr-15 mr-5 ht-40 br-5 fBold fs-14 ml-15"}
                  >Check Cost Estimation
                  </button>)
                }
                modal
                contentStyle={contentStyle}
              >
                {close =>
                  <>
                    <div className="modal scroll" style={{ padding: "10px", fontFamily: "Proximanova-Regular", height: "500px" }}>
                      <div style={{ padding: "10px 5px", display: "flex", justifyContent: "end", transform: "translate(5px, 5px)", color: "white", cursor: "pointer" }}>
                        <AiOutlineCloseCircle size="2em" onClick={close} />
                      </div>

                      <div style={{ background: "white", padding: "20px 20px 0px 20px", height: "500px", overflowY: "scroll" }}>
                        <div>
                          <div style={{ display: "flex", justifyContent: "space-between", fontWeight: "800", fontSize: "20px" }}>
                            Enter Commodity & Rake Details
                          </div>
                          <hr />
                        </div>

                        {/* HIDE AND SHOW PART DROPDOWN */}
                        <div>
                          <div style={{ width: "100%", gap: "20px" }}>
                            <table style={{ boxShadow: 'rgba(136, 165, 300, 0.6) 0px 0px 5px 0px, rgba(255, 255, 255, 0.7) 0px 0px 5px 0px', width: "100%", borderSpacing: '0px', marginTop: "30px", overflowY: "scroll" }}>
                              <thead className="ht-40 fs-14 fBold curP table-bg-blue white-color" style={{ display: "flex", justifyContent: "space-between", paddingTop: "10px" }}>
                                <tr className="br-10" style={{ alignItems: "start" }}>
                                  <th className=''>
                                    <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                                      <div style={{ paddingLeft: "5px" }}>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="15" height="18" viewBox="0 0 15 21">
                                          <g fill="none" fill-rule="nonzero">
                                            <path fill="#9FA8DA" d="M7.5 0C3.364 0 0 3.412 0 7.605 0 12.81 6.712 20.45 6.998 20.773a.67.67 0 0 0 1.004 0C8.288 20.45 15 12.81 15 7.605 15 3.412 11.635 0 7.5 0zm0 19.266c-2.259-2.72-6.15-8.089-6.15-11.66 0-3.44 2.76-6.236 6.15-6.236 3.39 0 6.15 2.797 6.15 6.235 0 3.572-3.89 8.94-6.15 11.661z" />
                                            <path fill="#FFF" d="M7.5 19.266c-2.259-2.72-6.15-8.089-6.15-11.66 0-3.44 2.76-6.236 6.15-6.236 3.39 0 6.15 2.797 6.15 6.235 0 3.572-3.89 8.94-6.15 11.661z" />
                                            <path fill="#9FA8DA" d="M7.5 3.23c-2.394 0-4.342 1.994-4.342 4.443 0 2.45 1.948 4.442 4.342 4.442 2.394 0 4.342-1.992 4.342-4.442S9.894 3.231 7.5 3.231zm0 7.108c-1.524 0-2.763-1.195-2.763-2.665S5.977 5.008 7.5 5.008c1.524 0 2.763 1.195 2.763 2.665s-1.24 2.665-2.763 2.665z" />
                                          </g>
                                        </svg>
                                      </div>
                                      <span>{this.state.destination_Yard}</span>
                                    </div>
                                  </th>
                                </tr>
                              </thead>

                              <tbody>
                                <tr>
                                  <td style={{ padding: "20px" }}>
                                    {this.state.values.map((element, index) => (
                                      <div className="input-fields" key={element.id} style={{ display: "flex", marginBottom: "15px" }}>
                                        <div className="fs-14 header-dark-color mr-10">
                                          <div style={{ paddingBottom: "5px", color: "blue", fontWeight: "700" }}>
                                            {element.commodityCategory}
                                          </div>
                                          <Dropdown
                                            items={Commodity_cat}
                                            label="Commodity Category"
                                            displayKey="label"
                                            selectedItem={null}
                                            onSelect={this.selectCommodityCat}
                                            className="mb-0 wt-350 ht-30 wd-350"
                                            searchEnabled={true}
                                          />
                                        </div>
                                        <div className="fs-14 header-dark-color mr-10">
                                          <div style={{ paddingBottom: "5px", color: "blue", fontWeight: "700" }}>
                                            {element.commodityName}
                                          </div>
                                          <Dropdown
                                            items={Commodity_name}
                                            label="Commodity Name"
                                            displayKey="label"
                                            selectedItem={null}
                                            onSelect={this.selectCommodityName}
                                            className="mb-0 wt-350 ht-30 wd-350"
                                            searchEnabled={true}
                                          />
                                        </div>
                                        <div className="fs-14 header-dark-color mr-10">
                                          <div style={{ paddingBottom: "5px", color: "blue", fontWeight: "700" }}>
                                            {element.rake}
                                          </div>
                                          <Dropdown
                                            items={Rake}
                                            label="Full Rake"
                                            displayKey="label"
                                            onSelect={this.selectRake}
                                            className="mb-0 wt-350 ht-30"
                                            searchEnabled={true}
                                          />
                                        </div>
                                        <div className="fs-14 header-dark-color mr-10">
                                          <div style={{ paddingBottom: "5px", color: "blue", fontWeight: "700" }}>
                                            {element.typeWagon}
                                          </div>
                                          <Dropdown
                                            items={Wagon_type}
                                            label="BCN"
                                            displayKey="label"
                                            selectedItem={null}
                                            onSelect={this.selectWagonType}
                                            className="wt-180 mb-0 wd-200 ht-30"
                                            searchEnabled={true}
                                          />
                                        </div>
                                        <div className="fs-14 header-dark-color mr-10">
                                          <div style={{ paddingBottom: "5px", color: "blue", fontWeight: "700" }}>
                                            {element.numberWagonn}
                                          </div>
                                          <Input
                                            type="number"
                                            value={this.state.wagon}
                                            onChange={this.handleInputChange}
                                            className="mb-0 wt-150 ht-30 wd-100"
                                            style={{ height: "36px", background: "white", borderRadius: "5px", display: "flex", alignItems: "center", border: "1px solid #528aea" }}
                                          />
                                        </div>
                                        <div className="fs-14 header-dark-color mr-10">
                                          <div style={{ paddingBottom: "5px", color: "blue", fontWeight: "700" }}>
                                            {element.weightWagon}
                                          </div>
                                          <Input
                                            type="number"
                                            value={this.state.wagonWt}
                                            onChange={this.handleInput2Change}
                                            className="mb-0 wt-150 ht-30 wd-100"
                                            style={{ height: "36px", background: "white", borderRadius: "5px", border: "1px solid #528aea" }}
                                          />
                                        </div>
                                        {
                                          index ?
                                            <div className="fs-14 header-dark-color cursor-pointer">
                                              <br></br>
                                              <br></br>
                                              <AiOutlineCloseCircle style={{ width: "25px", height: "25px", color: "#528aea", cursor: "pointer" }} onClick={() => this.removeFields(index)} />

                                            </div>
                                            :
                                            <div className="fs-14 header-dark-color cursor-pointer">
                                              <br></br>
                                              <br></br>
                                              <AiOutlinePlusCircle style={{ width: "25px", height: "25px", color: "#528aea", cursor: "pointer" }} onClick={() => this.addFields()} />

                                            </div>
                                        }
                                      </div>
                                    ))
                                    }
                                  </td>
                                </tr>

                              </tbody>

                            </table>
                          </div>
                        </div>
                      </div>
                      <div className="actions" style={{ display: "flex", justifyContent: "end", paddingTop: "20px", width: "100%", position: "sticky", bottom: "0", background: "white", paddingBottom: "15px", paddingRight: "20px" }}>
                        <button
                          style={{ border: "1px solid #528aea", color: "#528aea" }}
                          className={"wt-250 pl-15 pr-15 mr-5 ht-40 br-5 fBold fs-14 ml-15"}
                          onClick={close}
                        >Cancel
                        </button>
                        <button
                          data={this.sendState}
                          onClick={() => { this.props.history.push('/singleCostEstimation') }}
                          className={"bg-theme wt-250 pl-15 pr-15 mr-5 ht-40 br-5 fBold fs-14 white-color ml-15"}
                        >Check Cost Estimation
                        </button>

                      </div>
                    </div>
                  </>
                }
              </Popup>
            </div>

            {routeData && routeData.length > 0 && this.checkGenerateContractButton(routeData) &&
              <div style={{ paddingTop: "20px", justifyContent: "end" }}>
                <Popup
                  trigger={
                    (<button
                      className={"bg-theme wt-250 pl-15 pr-15 mr-5 ht-40 br-5 fBold fs-14 white-color ml-15"}
                    >Preview & Generate Contract
                    </button>)
                  }
                  modal={true}
                  contentStyle={contentStyle}
                >

                  {close =>

                    //(this.state.selectedArray.length > 0) ?
                    <>

                      <div style={{ boxShadow: "0 0 27px 4px rgb(69 68 68 / 40%)", padding: "20px", background: "white", height: "500px", overflowY: "scroll" }}>
                        <div style={{ padding: "10px 5px", display: "flex", cursor: "pointer", position: 'absolute', marginLeft: '98%', marginTop: '-5%', color: 'white' }}>
                          <AiOutlineCloseCircle size="2em" onClick={close} />
                        </div>

                        {/* <div style={{ padding: "10px 0px", width: "50%" }}>
                        <div style={{ display: "grid", gridTemplateColumns: "repeat(5, 1fr)" }}>

                          <div style={{ fontWeight: "800" }}>Route Code:</div>
                          <div style={{ fontWeight: "800" }}>From:</div>
                          <div style={{ fontWeight: "800" }}>To:</div>
                          <div style={{ fontWeight: "800" }}>Origin Yard:</div>
                          <div style={{ fontWeight: "800" }}>Destination Yard:</div>

                          <span className="span">{this.state.routeCode}</span>
                          <span className="span">{this.state.from}</span>
                          <span className="span">{this.state.to}</span>
                          <span className="span">{this.state.originYard}</span>
                          <span className="span">{this.state.destination_Yard}</span>
                        </div>
                      </div> */}

                        {
                          !!routeData && !!routeData.length && routeData.map((ele, idx) => {
                            const heading = Object.keys(ele)[0];
                            return (
                              <table style={{ boxShadow: 'rgba(136, 165, 300, 0.6) 0px 0px 5px 0px, rgba(255, 255, 255, 0.7) 0px 0px 5px 0px', width: "100%", borderSpacing: '0px', marginTop: "30px", borderCollapse: 'collapse' }}>
                                <thead className="ht-40 fs-14 fBold mr-5 mt-10 curP table-bg-blue white-color">
                                  <tr className="br-10">
                                    <th className=''>
                                      <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                                        <div style={{ paddingLeft: "5px" }}>
                                          <svg xmlns="http://www.w3.org/2000/svg" width="15" height="18" viewBox="0 0 15 21">
                                            <g fill="none" fill-rule="nonzero">
                                              <path fill="#9FA8DA" d="M7.5 0C3.364 0 0 3.412 0 7.605 0 12.81 6.712 20.45 6.998 20.773a.67.67 0 0 0 1.004 0C8.288 20.45 15 12.81 15 7.605 15 3.412 11.635 0 7.5 0zm0 19.266c-2.259-2.72-6.15-8.089-6.15-11.66 0-3.44 2.76-6.236 6.15-6.236 3.39 0 6.15 2.797 6.15 6.235 0 3.572-3.89 8.94-6.15 11.661z" />
                                              <path fill="#FFF" d="M7.5 19.266c-2.259-2.72-6.15-8.089-6.15-11.66 0-3.44 2.76-6.236 6.15-6.236 3.39 0 6.15 2.797 6.15 6.235 0 3.572-3.89 8.94-6.15 11.661z" />
                                              <path fill="#9FA8DA" d="M7.5 3.23c-2.394 0-4.342 1.994-4.342 4.443 0 2.45 1.948 4.442 4.342 4.442 2.394 0 4.342-1.992 4.342-4.442S9.894 3.231 7.5 3.231zm0 7.108c-1.524 0-2.763-1.195-2.763-2.665S5.977 5.008 7.5 5.008c1.524 0 2.763 1.195 2.763 2.665s-1.24 2.665-2.763 2.665z" />
                                            </g>
                                          </svg>
                                        </div>
                                        <span>{heading}</span>
                                      </div></th>

                                    {/* <th className='col-4 tLeft'><Checkbox type="square" label="L1" checked={this.state.selectedArray4.length === this.state.allData4.length} onCheck={() => { this.selectAllScheduleRecords4() }} /></th>
                      <th className='col-4 tLeft'><Checkbox type="square" label="L2" checked={this.state.selectedArray5.length === this.state.allData5.length} onCheck={() => { this.selectAllScheduleRecords5() }} /></th>
                      <th className='col-4 tLeft'><Checkbox type="square" label="L3" checked={this.state.selectedArray6.length === this.state.allData6.length} onCheck={() => { this.selectAllScheduleRecords6() }} /></th> */}

                                    <th className='col-4 tLeft' onCheck={() => { this.selectAllScheduleRecords() }}>L1</th>
                                    <th className='col-4 tLeft' onCheck={() => { this.selectAllScheduleRecords2() }}>L2</th>
                                    <th className='col-4 tLeft' onCheck={() => { this.selectAllScheduleRecords3() }}>L3</th>
                                  </tr>
                                </thead>


                                <tbody className="ht-40 fs-14 fBold mr-5 mt-10 curP label-color">
                                  {/* FIRST TABLE */}

                                  {
                                    Object.keys(ele[heading]).map((subEle, sIndex) => {

                                      const data = ele[heading][subEle]

                                      if (data && data.length && data.find(info => info.is_selected == true)) {
                                        return (
                                          <tr key={sIndex} style={{ borderBottom: '1px solid black' }} >
                                            <td className="tLeft p-5 pl-10  master-contract-font-color last-child">
                                              {this.getRowHeading(subEle) || '-'}
                                            </td>

                                            {
                                              ['L1', 'L2', 'L3'].map((type) => {
                                                return (
                                                  <td style={{ padding: "20px 0px" }}>
                                                    {data.map((info, dIndex) => {
                                                      return (
                                                        <>
                                                          {info.is_selected && (type == info.order_text) && <div style={{ paddingBottom: `${(data.length > (dIndex + 1)) ? '20px' : '0px'}` }}>
                                                            <div>
                                                              <th className='tLeft' key={idx}>
                                                                <div className="label ml-5 table-text-color fs-16">{info.transporter_name}</div></th>
                                                            </div>
                                                            <span style={{ paddingTop: "10px", paddingLeft: "20px", display: "flex", gap: "10px", alignItems: "center" }}>
                                                              <storng>Rate:</storng>  {info.price} Per MT
                                                              <span style={{ background: "green", color: "white", padding: "5px", borderRadius: "99px" }}>{info.order_text}</span>
                                                            </span>

                                                            <div style={{ display: "flex", paddingLeft: "20px", paddingTop: "10px", gap: "20px" }}>
                                                              <div style={{ fontSize: "12px", fontWeight: "800" }}> Contract Tenure:
                                                                <div style={{ fontWeight: "normal", paddingTop: "8px" }}>{moment(info.contract_tenure_from).format('DD-MM-YYYY')} To {moment(info.contract_tenure_to).format('DD-MM-YYYY')}</div>
                                                              </div>
                                                            </div>
                                                          </div>}


                                                          {ele.check2 && ele.Rate2 &&
                                                            <td style={{ color: "rgb(164, 164, 164)", borderBottom: "1px solid black" }}>
                                                              <div style={{ paddingBottom: "10px" }}>
                                                                {/* <th className='col-4 tLeft'><Checkbox type="square" label={ele.check2} onCheck={() => { this.checkedFullRow2(ele) }} checked={this.state.selectedArray2.find(obj => obj.id === ele.id)} /></th> */}
                                                              </div>
                                                              <span style={{ paddingTop: "10px", paddingLeft: "20px", fontSize: "15px" }}>
                                                                <storng>Rate:</storng>   {ele.Rate2} Per MT
                                                                <span style={{ background: "orange", color: "white", padding: "5px", borderRadius: "99px", marginLeft: "5px" }}>L2</span>
                                                              </span>
                                                              <div style={{ paddingLeft: "20px", paddingTop: "10px", paddingBottom: "10px" }}>

                                                                <button style={{ padding: "5px 10px", background: "#528aea", color: "white", borderRadius: "5px" }}>
                                                                  send LOI
                                                                </button>
                                                              </div>
                                                              <div></div>
                                                            </td>}

                                                          {ele.check3 && ele.Rate3 &&
                                                            <td style={{ color: "rgb(164, 164, 164)", borderBottom: "1px solid black" }}>
                                                              <div style={{ paddingBottom: "10px" }}>
                                                                {/* <th className='col-4 tLeft'><Checkbox type="square" label={ele.check3} onCheck={() => { this.checkedFullRow3(ele) }} checked={this.state.selectedArray3.find(obj => obj.id === ele.id)} /></th> */}
                                                              </div>
                                                              <span style={{ paddingTop: "10px", paddingLeft: "20px", fontSize: "15px" }}>
                                                                <storng>Rate:</storng>   {ele.Rate3} Per MT
                                                                <span style={{ background: "orange", color: "white", padding: "5px", borderRadius: "99px", marginLeft: "5px" }}>L3</span>
                                                              </span>
                                                              <div style={{ paddingLeft: "20px", paddingTop: "10px", paddingBottom: "10px" }}>

                                                                <button style={{ padding: "5px 10px", background: "#528aea", color: "white", borderRadius: "5px" }}>
                                                                  send LOI
                                                                </button>
                                                              </div>
                                                              <div></div>
                                                            </td>}
                                                        </>
                                                      )
                                                    })
                                                    }
                                                  </td>
                                                )
                                              })
                                            }

                                          </tr>
                                        )

                                      }
                                    })
                                  }
                                </tbody>
                              </table>
                            )
                          })
                        }

                        {/* <>
                        {!!routeData && !!routeData.length && routeData.map((ele, idx) => {
                          return (
                            <div style={{ boxShadow: "0 0 27px 4px rgb(69 68 68 / 40%)", padding: "20px", background: "white", height: "500px", overflowY: "scroll" }}>
                              <div onClick={this.Handlechange} style={{ cursor: "pointer" }}>
                                <div style={{ display: "flex", justifyContent: "space-between", fontWeight: "800", fontSize: "20px" }}>
                                  Contract No : 23456666
                                  <span>{!this.state.show ? <IoIosArrowDropdown size="1.5em" color="#528aea" style={{ cursor: "pointer" }} /> : <IoIosArrowDropup size="1.5em" color="#528aea" style={{ cursor: "pointer" }} />}</span>
                                </div>
                                <hr />
                              </div>

                              <div style={{ padding: "10px 0px", width: "50%" }}>
                                <div style={{ display: "grid", gridTemplateColumns: "repeat(5, 1fr)" }}>

                                  <div style={{ fontWeight: "800" }}>Route Code:</div>
                                  <div style={{ fontWeight: "800" }}>From:</div>
                                  <div style={{ fontWeight: "800" }}>To:</div>
                                  <div style={{ fontWeight: "800" }}>Origin Yard:</div>
                                  <div style={{ fontWeight: "800" }}>Destination Yard:</div>

                                  <span className="span">{this.state.routeCode}</span>
                                  <span className="span">{this.state.from}</span>
                                  <span className="span">{this.state.to}</span>
                                  <span className="span">{this.state.originYard}</span>
                                  <span className="span">{this.state.destination_Yard}</span>
                                </div>
                              </div>

                              <div style={{ padding: "10px 0px", width: "100%" }}>
                                <div style={{ display: "grid", gridTemplateColumns: "repeat(6, 1fr)" }}>

                                  <div style={{ fontWeight: "800" }}>Rake:</div>
                                  <div style={{ fontWeight: "800" }}>Commodity Category:</div>
                                  <div style={{ fontWeight: "800" }}>Commodity Name:</div>
                                  <div style={{ fontWeight: "800" }}>Type of Wagon:</div>
                                  <div style={{ fontWeight: "800" }}>No of Wagon:</div>
                                  <div style={{ fontWeight: "800" }}>Wagon Wt:</div>

                                  <span className="span">{this.state.rakeOf}</span>
                                  <span className="span">{this.state.commodity_cato}</span>
                                  <span className="span">{this.state.commodity_N}</span>
                                  <span className="span">{this.state.WagonType}</span>
                                  <span className="span">{this.state.wagon}</span>
                                  <span className="span">{this.state.wagonWt} per MT Wagon</span>
                                </div>
                              </div>

                              <div style={{ padding: "20px 0" }}>


                                <div style={{ display: "grid", gridTemplateColumns: "repeat(2, 1fr)", gap: "20px", width: "50%" }}>

                                  <div style={{ display: "block", padding: "10px 10px", background: "blue", color: "white", fontWeight: "700" }}>
                                    <p>Total Cost : 35,05,000</p>
                                    <p> Cost / PTPK :1430 PTPK<span style={{ background: "green", color: "white", padding: "15px", borderRadius: "99px", marginLeft: "100px" }}>L1</span></p>
                                    <p>Cost / MT : 4500 per MT</p>
                                  </div>

                                  <div style={{ display: "block", padding: "10px 10px", background: "blue", color: "white", fontWeight: "700" }}>
                                    <p>Total Cost : 35,05,000</p>
                                    <p> Cost / PTPK : 1430 PTPK<span style={{ background: "orange", color: "white", padding: "15px", borderRadius: "99px", marginLeft: "100px" }}>L2</span></p>
                                    <p>Cost / MT : 4500 per MT</p>
                                  </div>

                                </div>


                                {this.state.show &&
                                  <div>
                                    <div style={{ display: "grid", gridTemplateColumns: "repeat(2, 1fr)", width: "50%", gap: "20px", height: "auto" }}>

                                      <table style={{ boxShadow: 'rgba(136, 165, 300, 0.6) 0px 0px 5px 0px, rgba(255, 255, 255, 0.7) 0px 0px 5px 0px', width: "100%", borderSpacing: '0px', marginTop: "30px", height: "10px" }}>
                                        <thead className="ht-40 fs-14 fBold curP table-bg-blue white-color" style={{ display: "flex", alignItems: "center", justifyContent: "space-between", paddingRight: "10px" }}>
                                          <tr className="br-10">
                                            <th className=''>
                                              <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                                                <div style={{ paddingLeft: "5px" }}>
                                                  <svg xmlns="http://www.w3.org/2000/svg" width="15" height="18" viewBox="0 0 15 21">
                                                    <g fill="none" fill-rule="nonzero">
                                                      <path fill="#9FA8DA" d="M7.5 0C3.364 0 0 3.412 0 7.605 0 12.81 6.712 20.45 6.998 20.773a.67.67 0 0 0 1.004 0C8.288 20.45 15 12.81 15 7.605 15 3.412 11.635 0 7.5 0zm0 19.266c-2.259-2.72-6.15-8.089-6.15-11.66 0-3.44 2.76-6.236 6.15-6.236 3.39 0 6.15 2.797 6.15 6.235 0 3.572-3.89 8.94-6.15 11.661z" />
                                                      <path fill="#FFF" d="M7.5 19.266c-2.259-2.72-6.15-8.089-6.15-11.66 0-3.44 2.76-6.236 6.15-6.236 3.39 0 6.15 2.797 6.15 6.235 0 3.572-3.89 8.94-6.15 11.661z" />
                                                      <path fill="#9FA8DA" d="M7.5 3.23c-2.394 0-4.342 1.994-4.342 4.443 0 2.45 1.948 4.442 4.342 4.442 2.394 0 4.342-1.992 4.342-4.442S9.894 3.231 7.5 3.231zm0 7.108c-1.524 0-2.763-1.195-2.763-2.665S5.977 5.008 7.5 5.008c1.524 0 2.763 1.195 2.763 2.665s-1.24 2.665-2.763 2.665z" />
                                                    </g>
                                                  </svg>
                                                </div>
                                                <span>{this.state.from}</span>
                                              </div>
                                            </th>
                                          </tr>
                                          <tr>8200</tr>
                                        </thead>
                                        <tbody style={{ padding: "10px" }} className="ht-40 fs-14 fBold mr-5 mt-10 curP label-color">


                                          {this.state.selectedArray.map((ele) => {
                                            return (
                                              <tr>
                                                <td style={{ borderRight: "0px solid", paddingTop: "10px", borderBottom: "1px solid black" }} className="tLeft p-5 pl-10">
                                                  <div>
                                                    {ele.check1}
                                                  </div>
                                                  <span style={{ paddingTop: "10px", display: "flex", gap: "20px", alignItems: "center" }}>
                                                    <storng>Rate:</storng> {ele.Rate} Per MT
                                                    <span style={{ background: "green", color: "white", padding: "5px", borderRadius: "99px" }}>L1</span>
                                                  </span>

                                                  <div style={{ display: "flex", paddingTop: "10px", gap: "20px" }}>
                                                    <div style={{ fontSize: "12px", fontWeight: "800" }}>
                                                      SAP Contract No:
                                                      <div style={{ fontWeight: "normal", paddingTop: "8px", paddingBottom: "10px" }}>{ele.Contract_No}</div>
                                                    </div>
                                                    <div style={{ fontSize: "12px", fontWeight: "800" }}> Contract Tenure:
                                                      <div style={{ fontWeight: "normal", paddingTop: "8px" }}>{ele.date}</div>
                                                    </div>
                                                  </div>
                                                </td>
                                              </tr>
                                            )
                                          })}

                                        </tbody>
                                      </table>

                                      <table style={{ boxShadow: 'rgba(136, 165, 300, 0.6) 0px 0px 5px 0px, rgba(255, 255, 255, 0.7) 0px 0px 5px 0px', width: "100%", borderSpacing: '0px', marginTop: "30px", height: "10px" }}>
                                        <thead className="ht-40 fs-14 fBold curP table-bg-blue white-color" style={{ display: "flex", alignItems: "center", justifyContent: "space-between", paddingRight: "10px" }}>
                                          <tr className="br-10">
                                            <th className=''>
                                              <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                                                <div style={{ paddingLeft: "5px" }}>
                                                  <svg xmlns="http://www.w3.org/2000/svg" width="15" height="18" viewBox="0 0 15 21">
                                                    <g fill="none" fill-rule="nonzero">
                                                      <path fill="#9FA8DA" d="M7.5 0C3.364 0 0 3.412 0 7.605 0 12.81 6.712 20.45 6.998 20.773a.67.67 0 0 0 1.004 0C8.288 20.45 15 12.81 15 7.605 15 3.412 11.635 0 7.5 0zm0 19.266c-2.259-2.72-6.15-8.089-6.15-11.66 0-3.44 2.76-6.236 6.15-6.236 3.39 0 6.15 2.797 6.15 6.235 0 3.572-3.89 8.94-6.15 11.661z" />
                                                      <path fill="#FFF" d="M7.5 19.266c-2.259-2.72-6.15-8.089-6.15-11.66 0-3.44 2.76-6.236 6.15-6.236 3.39 0 6.15 2.797 6.15 6.235 0 3.572-3.89 8.94-6.15 11.661z" />
                                                      <path fill="#9FA8DA" d="M7.5 3.23c-2.394 0-4.342 1.994-4.342 4.443 0 2.45 1.948 4.442 4.342 4.442 2.394 0 4.342-1.992 4.342-4.442S9.894 3.231 7.5 3.231zm0 7.108c-1.524 0-2.763-1.195-2.763-2.665S5.977 5.008 7.5 5.008c1.524 0 2.763 1.195 2.763 2.665s-1.24 2.665-2.763 2.665z" />
                                                    </g>
                                                  </svg>
                                                </div>
                                                <span>{this.state.from}</span>
                                              </div>
                                            </th>
                                          </tr>
                                          <tr> 8200</tr>
                                        </thead>
                                        <tbody style={{ padding: "10px" }} className="ht-40 fs-14 fBold mr-5 mt-10 curP label-color">

                                          {this.state.selectedArray2.map((ele) => {
                                            return (
                                              <tr>
                                                <td style={{ borderRight: "0px solid", paddingTop: "10px", borderBottom: "1px solid black" }} className="tLeft p-5 pl-10">
                                                  <div>
                                                    {ele.check2}
                                                  </div>
                                                  <span style={{ paddingTop: "10px", display: "flex", gap: "20px", alignItems: "center" }}>
                                                    <storng>Rate:</storng> {ele.Rate2} Per MT
                                                    <span style={{ background: "orange", color: "white", padding: "5px", borderRadius: "99px" }}>L2</span>
                                                  </span>

                                                  <div style={{ display: "flex", paddingTop: "10px", gap: "20px" }}>
                                                    <div style={{ fontSize: "12px", fontWeight: "800" }}>
                                                      SAP Contract No:
                                                      <div style={{ fontWeight: "normal", paddingTop: "8px", paddingBottom: "10px" }}>{ele.Contract_No}</div>
                                                    </div>
                                                    <div style={{ fontSize: "12px", fontWeight: "800" }}> Contract Tenure:
                                                      <div style={{ fontWeight: "normal", paddingTop: "8px" }}>{ele.date}</div>
                                                    </div>
                                                  </div>
                                                </td>
                                              </tr>)
                                          })}

                                          {this.state.selectedArray3.map((ele) => {
                                            return (
                                              <tr>
                                                <td style={{ borderRight: "0px solid", paddingTop: "10px", borderBottom: "1px solid black" }} className="tLeft p-5 pl-10">
                                                  <div>
                                                    {ele.check3}
                                                  </div>
                                                  <span style={{ paddingTop: "10px", display: "flex", gap: "20px", alignItems: "center" }}>
                                                    <storng>Rate:</storng> {ele.Rate3} Per MT
                                                    <span style={{ background: "orange", color: "white", padding: "5px", borderRadius: "99px" }}>L3</span>
                                                  </span>

                                                  <div style={{ display: "flex", paddingTop: "10px", gap: "20px" }}>
                                                    <div style={{ fontSize: "12px", fontWeight: "800" }}>
                                                      SAP Contract No:
                                                      <div style={{ fontWeight: "normal", paddingTop: "8px", paddingBottom: "10px" }}>{ele.Contract_No}</div>
                                                    </div>
                                                    <div style={{ fontSize: "12px", fontWeight: "800" }}> Contract Tenure:
                                                      <div style={{ fontWeight: "normal", paddingTop: "8px" }}>{ele.date}</div>
                                                    </div>
                                                  </div>
                                                </td>
                                              </tr>)
                                          })}

                                        </tbody>
                                      </table>

                                    </div>

                                    <div style={{ display: "grid", gridTemplateColumns: "repeat(2, 1fr)", width: "50%", gap: "20px" }}>

                                      <table style={{ boxShadow: 'rgba(136, 165, 300, 0.6) 0px 0px 5px 0px, rgba(255, 255, 255, 0.7) 0px 0px 5px 0px', width: "100%", borderSpacing: '0px', marginTop: "30px" }}>
                                        <thead className="ht-40 fs-14 fBold mr-5 mt-10 curP table-bg-dark-red white-color">
                                          <tr className="br-10">
                                            <th className=''>
                                              <div style={{ display: "flex", alignItems: "center", gap: "0px" }}>
                                                <div style={{ paddingLeft: "0px" }}>
                                                  <svg xmlns="http://www.w3.org/2000/svg" width="50" height="30" viewBox="0 0 42 44">
                                                    <g fill="#FFF" fill-rule="evenodd" stroke-width=".5">
                                                      <path d="M1.1 43.731a.41.41 0 0 1-.21 0 .49.49 0 0 1-.24-.66l9.26-19.54a.49.49 0 0 1 .66-.24.5.5 0 0 1 .24.67L1.6 43.491a.48.48 0 0 1-.5.24zM40.42 43.731a.48.48 0 0 1-.45-.28l-9.26-19.49a.5.5 0 0 1 .24-.67.49.49 0 0 1 .66.24l9.26 19.53a.49.49 0 0 1-.27.67.41.41 0 0 1-.18 0z" />
                                                      <path d="M32.68 27.441H8.84a.5.5 0 1 1 0-1h23.84a.5.5 0 1 1 0 1zM35.37 33.671H5.85a.51.51 0 0 1-.5-.5.5.5 0 0 1 .5-.5h29.52a.5.5 0 1 1 0 1zM38.6 39.891H2.94a.5.5 0 0 1-.5-.5.51.51 0 0 1 .5-.5H38.6a.5.5 0 1 1 0 1z" />
                                                      <path fill-rule="nonzero" d="M31.33 24.241H10.44a2.61 2.61 0 0 1-2.61-2.61V3.341a2.61 2.61 0 0 1 2.61-2.61h20.89a2.61 2.61 0 0 1 2.61 2.61v18.29a2.61 2.61 0 0 1-2.61 2.61zM10.44 1.731c-.89 0-1.61.721-1.61 1.61v18.29c0 .89.72 1.61 1.61 1.61h20.89a1.61 1.61 0 0 0 1.61-1.61V3.341a1.61 1.61 0 0 0-1.61-1.61H10.44z" />
                                                      <path d="M33.44 16.381H8.33a.5.5 0 1 1 0-1h25.11a.5.5 0 1 1 0 1z" />
                                                      <path d="M20.65 16.381a.5.5 0 0 1-.5-.5V1.231a.5.5 0 1 1 1 0v14.65a.51.51 0 0 1-.5.5z" />
                                                      <path fill-rule="nonzero" d="M29.66 21.341a2 2 0 1 1 0-4 2 2 0 0 1 0 4zm0-3.09a1.045 1.045 0 1 0 0 2.09 1.045 1.045 0 0 0 0-2.09zM11.73 21.341a2 2 0 1 1 0-4 2 2 0 0 1 0 4zm0-3.09a1 1 0 1 0 .002 2 1 1 0 0 0-.003-2z" />
                                                      <path d="M22.6 21.081h-3.66a.5.5 0 1 1 0-1h3.66a.5.5 0 1 1 0 1z" />
                                                    </g>
                                                  </svg>
                                                </div>
                                                <span>Rail Fright</span>
                                              </div>
                                            </th>
                                            <th> 24,00,000</th>

                                          </tr>
                                        </thead>
                                        <tbody className="ht-40 fs-14 fBold mr-5 mt-10 curP label-color">

                                          <tr>
                                            <td style={{ borderRight: "0px solid", paddingTop: "10px" }} className="tLeft p-5 pl-10 ">
                                              <div>
                                                Cost / MT : 2500 per MT
                                              </div>
                                            </td>
                                          </tr>

                                        </tbody>
                                      </table>

                                      <table style={{ boxShadow: 'rgba(136, 165, 300, 0.6) 0px 0px 5px 0px, rgba(255, 255, 255, 0.7) 0px 0px 5px 0px', width: "100%", borderSpacing: '0px', marginTop: "30px" }}>
                                        <thead className="ht-40 fs-14 fBold mr-5 mt-10 curP table-bg-dark-red white-color">
                                          <tr className="br-10">
                                            <th className=''>
                                              <div style={{ display: "flex", alignItems: "center", gap: "0px" }}>
                                                <div style={{ paddingLeft: "0px" }}>
                                                  <svg xmlns="http://www.w3.org/2000/svg" width="50" height="30" viewBox="0 0 42 44">
                                                    <g fill="#FFF" fill-rule="evenodd" stroke-width=".5">
                                                      <path d="M1.1 43.731a.41.41 0 0 1-.21 0 .49.49 0 0 1-.24-.66l9.26-19.54a.49.49 0 0 1 .66-.24.5.5 0 0 1 .24.67L1.6 43.491a.48.48 0 0 1-.5.24zM40.42 43.731a.48.48 0 0 1-.45-.28l-9.26-19.49a.5.5 0 0 1 .24-.67.49.49 0 0 1 .66.24l9.26 19.53a.49.49 0 0 1-.27.67.41.41 0 0 1-.18 0z" />
                                                      <path d="M32.68 27.441H8.84a.5.5 0 1 1 0-1h23.84a.5.5 0 1 1 0 1zM35.37 33.671H5.85a.51.51 0 0 1-.5-.5.5.5 0 0 1 .5-.5h29.52a.5.5 0 1 1 0 1zM38.6 39.891H2.94a.5.5 0 0 1-.5-.5.51.51 0 0 1 .5-.5H38.6a.5.5 0 1 1 0 1z" />
                                                      <path fill-rule="nonzero" d="M31.33 24.241H10.44a2.61 2.61 0 0 1-2.61-2.61V3.341a2.61 2.61 0 0 1 2.61-2.61h20.89a2.61 2.61 0 0 1 2.61 2.61v18.29a2.61 2.61 0 0 1-2.61 2.61zM10.44 1.731c-.89 0-1.61.721-1.61 1.61v18.29c0 .89.72 1.61 1.61 1.61h20.89a1.61 1.61 0 0 0 1.61-1.61V3.341a1.61 1.61 0 0 0-1.61-1.61H10.44z" />
                                                      <path d="M33.44 16.381H8.33a.5.5 0 1 1 0-1h25.11a.5.5 0 1 1 0 1z" />
                                                      <path d="M20.65 16.381a.5.5 0 0 1-.5-.5V1.231a.5.5 0 1 1 1 0v14.65a.51.51 0 0 1-.5.5z" />
                                                      <path fill-rule="nonzero" d="M29.66 21.341a2 2 0 1 1 0-4 2 2 0 0 1 0 4zm0-3.09a1.045 1.045 0 1 0 0 2.09 1.045 1.045 0 0 0 0-2.09zM11.73 21.341a2 2 0 1 1 0-4 2 2 0 0 1 0 4zm0-3.09a1 1 0 1 0 .002 2 1 1 0 0 0-.003-2z" />
                                                      <path d="M22.6 21.081h-3.66a.5.5 0 1 1 0-1h3.66a.5.5 0 1 1 0 1z" />
                                                    </g>
                                                  </svg>
                                                </div>
                                                <span>Rail Fright</span>
                                              </div>
                                            </th>
                                            <th> 24,00,000</th>
                                          </tr>
                                        </thead>
                                        <tbody className="ht-40 fs-14 fBold mr-5 mt-10 curP label-color">

                                          <tr>
                                            <td style={{ borderRight: "0px solid", paddingTop: "10px" }} className="tLeft p-5 pl-10 ">
                                              <div>
                                                Cost / MT :2500 per MT
                                              </div>
                                            </td>
                                          </tr>


                                        </tbody>
                                      </table>

                                    </div>

                                    <div style={{ display: "grid", gridTemplateColumns: "repeat(2, 1fr)", width: "50%", gap: "20px" }}>

                                      <table style={{ boxShadow: 'rgba(136, 165, 300, 0.6) 0px 0px 5px 0px, rgba(255, 255, 255, 0.7) 0px 0px 5px 0px', width: "100%", borderSpacing: '0px', marginTop: "30px", height: "10px" }}>
                                        <thead className="ht-40 fs-14 fBold curP table-bg-blue white-color" style={{ display: "flex", alignItems: "center", justifyContent: "space-between", paddingRight: "10px" }}>
                                          <tr className="br-10">
                                            <th className=''>
                                              <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                                                <div style={{ paddingLeft: "5px" }}>
                                                  <svg xmlns="http://www.w3.org/2000/svg" width="15" height="18" viewBox="0 0 15 21">
                                                    <g fill="none" fill-rule="nonzero">
                                                      <path fill="#9FA8DA" d="M7.5 0C3.364 0 0 3.412 0 7.605 0 12.81 6.712 20.45 6.998 20.773a.67.67 0 0 0 1.004 0C8.288 20.45 15 12.81 15 7.605 15 3.412 11.635 0 7.5 0zm0 19.266c-2.259-2.72-6.15-8.089-6.15-11.66 0-3.44 2.76-6.236 6.15-6.236 3.39 0 6.15 2.797 6.15 6.235 0 3.572-3.89 8.94-6.15 11.661z" />
                                                      <path fill="#FFF" d="M7.5 19.266c-2.259-2.72-6.15-8.089-6.15-11.66 0-3.44 2.76-6.236 6.15-6.236 3.39 0 6.15 2.797 6.15 6.235 0 3.572-3.89 8.94-6.15 11.661z" />
                                                      <path fill="#9FA8DA" d="M7.5 3.23c-2.394 0-4.342 1.994-4.342 4.443 0 2.45 1.948 4.442 4.342 4.442 2.394 0 4.342-1.992 4.342-4.442S9.894 3.231 7.5 3.231zm0 7.108c-1.524 0-2.763-1.195-2.763-2.665S5.977 5.008 7.5 5.008c1.524 0 2.763 1.195 2.763 2.665s-1.24 2.665-2.763 2.665z" />
                                                    </g>
                                                  </svg>
                                                </div>
                                                <span>{this.state.to}</span>
                                              </div>
                                            </th>
                                          </tr>
                                          <tr> 8200</tr>
                                        </thead>
                                        <tbody style={{ padding: "10px" }} className="ht-40 fs-14 fBold mr-5 mt-10 curP label-color">
                                          {this.state.selectedArray4.map((ele) => {
                                            return (
                                              <tr>
                                                <td style={{ borderRight: "0px solid", paddingTop: "10px", borderBottom: "1px solid black" }} className="tLeft p-5 pl-10">
                                                  <div>
                                                    {ele.check1}
                                                  </div>
                                                  <span style={{ paddingTop: "10px", display: "flex", gap: "20px", alignItems: "center" }}>
                                                    <storng>Rate:</storng> {ele.Rate} Per MT
                                                    <span style={{ background: "green", color: "white", padding: "5px", borderRadius: "99px" }}>L1</span>
                                                  </span>

                                                  <div style={{ display: "flex", paddingTop: "10px", gap: "20px" }}>
                                                    <div style={{ fontSize: "12px", fontWeight: "800" }}>
                                                      SAP Contract No:
                                                      <div style={{ fontWeight: "normal", paddingTop: "8px", paddingBottom: "10px" }}>{ele.Contract_No}</div>
                                                    </div>
                                                    <div style={{ fontSize: "12px", fontWeight: "800" }}> Contract Tenure:
                                                      <div style={{ fontWeight: "normal", paddingTop: "8px" }}>{ele.date}</div>
                                                    </div>
                                                  </div>
                                                </td>
                                              </tr>
                                            )
                                          })}

                                        </tbody>
                                      </table>

                                      <table style={{ boxShadow: 'rgba(136, 165, 300, 0.6) 0px 0px 5px 0px, rgba(255, 255, 255, 0.7) 0px 0px 5px 0px', width: "100%", borderSpacing: '0px', marginTop: "30px", height: "10px" }}>
                                        <thead className="ht-40 fs-14 fBold curP table-bg-blue white-color" style={{ display: "flex", alignItems: "center", justifyContent: "space-between", paddingRight: "10px" }}>
                                          <tr className="br-10">
                                            <th className=''>
                                              <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                                                <div style={{ paddingLeft: "5px" }}>
                                                  <svg xmlns="http://www.w3.org/2000/svg" width="15" height="18" viewBox="0 0 15 21">
                                                    <g fill="none" fill-rule="nonzero">
                                                      <path fill="#9FA8DA" d="M7.5 0C3.364 0 0 3.412 0 7.605 0 12.81 6.712 20.45 6.998 20.773a.67.67 0 0 0 1.004 0C8.288 20.45 15 12.81 15 7.605 15 3.412 11.635 0 7.5 0zm0 19.266c-2.259-2.72-6.15-8.089-6.15-11.66 0-3.44 2.76-6.236 6.15-6.236 3.39 0 6.15 2.797 6.15 6.235 0 3.572-3.89 8.94-6.15 11.661z" />
                                                      <path fill="#FFF" d="M7.5 19.266c-2.259-2.72-6.15-8.089-6.15-11.66 0-3.44 2.76-6.236 6.15-6.236 3.39 0 6.15 2.797 6.15 6.235 0 3.572-3.89 8.94-6.15 11.661z" />
                                                      <path fill="#9FA8DA" d="M7.5 3.23c-2.394 0-4.342 1.994-4.342 4.443 0 2.45 1.948 4.442 4.342 4.442 2.394 0 4.342-1.992 4.342-4.442S9.894 3.231 7.5 3.231zm0 7.108c-1.524 0-2.763-1.195-2.763-2.665S5.977 5.008 7.5 5.008c1.524 0 2.763 1.195 2.763 2.665s-1.24 2.665-2.763 2.665z" />
                                                    </g>
                                                  </svg>
                                                </div>
                                                <span>{this.state.to}</span>
                                              </div>
                                            </th>
                                          </tr>
                                          <tr> 8200</tr>
                                        </thead>
                                        <tbody style={{ padding: "10px" }} className="ht-40 fs-14 fBold mr-5 mt-10 curP label-color">
                                          {this.state.selectedArray5.map((ele) => {
                                            return (
                                              <tr>
                                                <td style={{ borderRight: "0px solid", paddingTop: "10px", borderBottom: "1px solid black" }} className="tLeft p-5 pl-10">
                                                  <div>
                                                    {ele.check2}
                                                  </div>
                                                  <span style={{ paddingTop: "10px", display: "flex", gap: "20px", alignItems: "center" }}>
                                                    <storng>Rate:</storng> {ele.Rate2} Per MT
                                                    <span style={{ background: "green", color: "white", padding: "5px", borderRadius: "99px" }}>L1</span>
                                                  </span>

                                                  <div style={{ display: "flex", paddingTop: "10px", gap: "20px" }}>
                                                    <div style={{ fontSize: "12px", fontWeight: "800" }}>
                                                      SAP Contract No:
                                                      <div style={{ fontWeight: "normal", paddingTop: "8px", paddingBottom: "10px" }}>{ele.Contract_No}</div>
                                                    </div>
                                                    <div style={{ fontSize: "12px", fontWeight: "800" }}> Contract Tenure:
                                                      <div style={{ fontWeight: "normal", paddingTop: "8px" }}>{ele.date}</div>
                                                    </div>
                                                  </div>
                                                </td>
                                              </tr>
                                            )
                                          })}
                                          {this.state.selectedArray6.map((ele) => {
                                            return (
                                              <tr>
                                                <td style={{ borderRight: "0px solid", paddingTop: "10px", borderBottom: "1px solid black" }} className="tLeft p-5 pl-10">
                                                  <div>
                                                    {ele.check3}
                                                  </div>
                                                  <span style={{ paddingTop: "10px", display: "flex", gap: "20px", alignItems: "center" }}>
                                                    <storng>Rate:</storng> {ele.Rate3} Per MT
                                                    <span style={{ background: "green", color: "white", padding: "5px", borderRadius: "99px" }}>L1</span>
                                                  </span>

                                                  <div style={{ display: "flex", paddingTop: "10px", gap: "20px" }}>
                                                    <div style={{ fontSize: "12px", fontWeight: "800" }}>
                                                      SAP Contract No:
                                                      <div style={{ fontWeight: "normal", paddingTop: "8px", paddingBottom: "10px" }}>{ele.Contract_No}</div>
                                                    </div>
                                                    <div style={{ fontSize: "12px", fontWeight: "800" }}> Contract Tenure:
                                                      <div style={{ fontWeight: "normal", paddingTop: "8px" }}>{ele.date}</div>
                                                    </div>
                                                  </div>
                                                </td>
                                              </tr>
                                            )
                                          })}
                                        </tbody>
                                      </table>

                                    </div>

                                  </div>
                                }
                              </div>
                            </div>
                          )
                        }
                        )
                        }
                      </> */}


                        <div className="actions" style={{ display: "flex", justifyContent: "end", paddingTop: "20px" }}>
                          <button
                            className={"bg-theme wt-250 pl-15 pr-15 mr-5 ht-40 br-5 fBold fs-14 white-color ml-15"}
                            onClick={close}
                          >Cancel
                          </button>
                          <div style={{ display: "flex", justifyContent: "end", cursor: "pointer" }} onClick={() => this.generatePlan(close)}>
                            <div style={{ display: "flex", justifyContent: "center", height: '40px', paddingRight: "20px", border: "1px solid #528aea", width: "320px", alignItems: "center", backgroundColor: "#528aea", fontWeight: "700", color: "white", borderRadius: "5px" }}>
                              Generate Contract
                            </div>
                          </div>
                        </div>
                      </div>
                      {/* 
                    <div className="modal scroll" style={{ padding: "10px", fontFamily: "Proximanova-Regular", width: "100%" }}>
                      <div style={{ padding: "10px 5px", display: "flex", justifyContent: "end", transform: "translate(5px, 5px)", color: "white", cursor: "pointer" }}>
                        <AiOutlineCloseCircle size="2em" onClick={close} />
                      </div>

                      <div style={{ boxShadow: "0 0 27px 4px rgb(69 68 68 / 60%)", padding: "20px 20px 0px 20px", background: "white", height: "700px", overflowY: "scroll", width: "100%" }}>
                        <div>
                          <div style={{ display: "flex", justifyContent: "space-between", fontWeight: "800", fontSize: "20px" }}>
                            Contract No : 23456666
                          </div>
                          <hr />
                        </div>

                        <div style={{ padding: "10px 0px", width: "50%" }}>
                          <div style={{ display: "grid", gridTemplateColumns: "repeat(5, 1fr)" }}>

                            <div style={{ fontWeight: "800" }}>Route Code:</div>
                            <div style={{ fontWeight: "800" }}>From:</div>
                            <div style={{ fontWeight: "800" }}>To:</div>
                            <div style={{ fontWeight: "800" }}>Origin Yard:</div>
                            <div style={{ fontWeight: "800" }}>Destination Yard:</div>

                            <span className="span">{this.state.routeCode}</span>
                            <span className="span">{this.state.from}</span>
                            <span className="span">{this.state.to}</span>
                            <span className="span">{this.state.originYard}</span>
                            <span className="span">{this.state.destination_Yard}</span>
                          </div>
                        </div>

                        <div style={{ padding: "20px 0" }}>
                          <div>
                            <div style={{ width: "100%", gap: "20px" }}>

                              <table style={{ boxShadow: 'rgba(136, 165, 300, 0.6) 0px 0px 5px 0px, rgba(255, 255, 255, 0.7) 0px 0px 5px 0px', width: "100%", borderSpacing: '0px', marginTop: "30px" }}>
                                <thead className="ht-40 fs-14 fBold curP table-bg-blue white-color" style={{ display: "flex", justifyContent: "space-between", paddingTop: "10px" }}>
                                  <tr className="br-10" style={{ alignItems: "start" }}>
                                    <th className=''>
                                      <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                                        <div style={{ paddingLeft: "5px" }}>
                                          <svg xmlns="http://www.w3.org/2000/svg" width="15" height="18" viewBox="0 0 15 21">
                                            <g fill="none" fill-rule="nonzero">
                                              <path fill="#9FA8DA" d="M7.5 0C3.364 0 0 3.412 0 7.605 0 12.81 6.712 20.45 6.998 20.773a.67.67 0 0 0 1.004 0C8.288 20.45 15 12.81 15 7.605 15 3.412 11.635 0 7.5 0zm0 19.266c-2.259-2.72-6.15-8.089-6.15-11.66 0-3.44 2.76-6.236 6.15-6.236 3.39 0 6.15 2.797 6.15 6.235 0 3.572-3.89 8.94-6.15 11.661z" />
                                              <path fill="#FFF" d="M7.5 19.266c-2.259-2.72-6.15-8.089-6.15-11.66 0-3.44 2.76-6.236 6.15-6.236 3.39 0 6.15 2.797 6.15 6.235 0 3.572-3.89 8.94-6.15 11.661z" />
                                              <path fill="#9FA8DA" d="M7.5 3.23c-2.394 0-4.342 1.994-4.342 4.443 0 2.45 1.948 4.442 4.342 4.442 2.394 0 4.342-1.992 4.342-4.442S9.894 3.231 7.5 3.231zm0 7.108c-1.524 0-2.763-1.195-2.763-2.665S5.977 5.008 7.5 5.008c1.524 0 2.763 1.195 2.763 2.665s-1.24 2.665-2.763 2.665z" />
                                            </g>
                                          </svg>
                                        </div>
                                        <span>{this.state.from}</span>
                                      </div>
                                    </th>
                                  </tr>
                                </thead>

                                <tbody className="ht-40 fs-14 fBold mr-5 mt-10 curP label-color">
                                  {this.state.selectedArray.map((ele) => {
                                    return (
                                      <tr>
                                        <td style={{ borderRight: "0px solid", paddingTop: "10px", display: "flex", flexDirection: "row", alignItems: "center", borderBottom: "1px solid black" }} className="tLeft p-5 pl-10 pr-10">
                                          <div style={{ width: "40%" }}>
                                            {ele.check1}
                                          </div>
                                          <div style={{ display: "flex", gap: "25px", width: "50%" }}>
                                            <div style={{ fontSize: "12px", fontWeight: "800" }}>
                                              SAP Contract No:
                                              <div style={{ fontWeight: "normal", paddingTop: "8px", paddingBottom: "10px" }}>{ele.Contract_No}</div>
                                            </div>
                                            <div style={{ fontSize: "12px", fontWeight: "800" }}> Contract Tenure:
                                              <div style={{ fontWeight: "normal", paddingTop: "8px" }}>{ele.date}</div>
                                            </div>
                                          </div>

                                          <div>
                                            Rate: {ele.Rate} per MT
                                          </div>
                                        </td>
                                      </tr>
                                    )
                                  })}
                                </tbody>
                              </table>

                            </div>

                            <div style={{ width: "100%", gap: "20px" }}>

                              <table style={{ boxShadow: 'rgba(136, 165, 300, 0.6) 0px 0px 5px 0px, rgba(255, 255, 255, 0.7) 0px 0px 5px 0px', width: "100%", borderSpacing: '0px', marginTop: "30px" }}>
                                <thead className="ht-40 fs-14 fBold curP table-bg-blue white-color" style={{ display: "flex", justifyContent: "space-between", paddingTop: "10px" }}>
                                  <tr className="br-10" style={{ alignItems: "start" }}>
                                    <th className=''>
                                      <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                                        <div style={{ paddingLeft: "5px" }}>
                                          <svg xmlns="http://www.w3.org/2000/svg" width="15" height="18" viewBox="0 0 15 21">
                                            <g fill="none" fill-rule="nonzero">
                                              <path fill="#9FA8DA" d="M7.5 0C3.364 0 0 3.412 0 7.605 0 12.81 6.712 20.45 6.998 20.773a.67.67 0 0 0 1.004 0C8.288 20.45 15 12.81 15 7.605 15 3.412 11.635 0 7.5 0zm0 19.266c-2.259-2.72-6.15-8.089-6.15-11.66 0-3.44 2.76-6.236 6.15-6.236 3.39 0 6.15 2.797 6.15 6.235 0 3.572-3.89 8.94-6.15 11.661z" />
                                              <path fill="#FFF" d="M7.5 19.266c-2.259-2.72-6.15-8.089-6.15-11.66 0-3.44 2.76-6.236 6.15-6.236 3.39 0 6.15 2.797 6.15 6.235 0 3.572-3.89 8.94-6.15 11.661z" />
                                              <path fill="#9FA8DA" d="M7.5 3.23c-2.394 0-4.342 1.994-4.342 4.443 0 2.45 1.948 4.442 4.342 4.442 2.394 0 4.342-1.992 4.342-4.442S9.894 3.231 7.5 3.231zm0 7.108c-1.524 0-2.763-1.195-2.763-2.665S5.977 5.008 7.5 5.008c1.524 0 2.763 1.195 2.763 2.665s-1.24 2.665-2.763 2.665z" />
                                            </g>
                                          </svg>
                                        </div>
                                        <span>{this.state.to}</span>
                                      </div>
                                    </th>
                                  </tr>
                                </thead>

                                <tbody className="ht-40 fs-14 fBold mr-5 mt-10 curP label-color">
                                  {this.state.selectedArray4.slice(1).map((ele) => {
                                    return (
                                      <tr>
                                        <td style={{ borderRight: "0px solid", paddingTop: "10px", display: "flex", flexDirection: "row", alignItems: "center", borderBottom: "1px solid black" }} className="tLeft p-5 pl-10 pr-10">
                                          <div style={{ width: "40%" }}>
                                            {ele.check1}
                                          </div>
                                          <div style={{ display: "flex", gap: "25px", width: "50%" }}>
                                            <div style={{ fontSize: "12px", fontWeight: "800" }}>
                                              SAP Contract No:
                                              <div style={{ fontWeight: "normal", paddingTop: "8px", paddingBottom: "10px" }}>{ele.Contract_No}</div>
                                            </div>
                                            <div style={{ fontSize: "12px", fontWeight: "800" }}> Contract Tenure:
                                              <div style={{ fontWeight: "normal", paddingTop: "8px" }}>{ele.date}</div>
                                            </div>
                                          </div>

                                          <div>
                                            Rate: {ele.Rate} per MT
                                          </div>
                                        </td>
                                      </tr>
                                    )
                                  })}
                                </tbody>
                              </table>

                            </div>
                          </div>
                        </div>

                        <div className="actions" style={{ display: "flex", justifyContent: "end", paddingTop: "20px", width: "100%", position: "sticky", bottom: "0", background: "white", paddingBottom: "15px" }}>
                          <button
                            style={{ border: "1px solid #528aea", color: "#528aea" }}
                            className={"wt-250 pl-15 pr-15 mr-5 ht-40 br-5 fBold fs-14 ml-15"}
                            onClick={close}
                          >Cancel
                          </button>
                          <Popup
                            trigger={<button
                              className={"bg-theme wt-250 pl-15 pr-15 mr-5 ht-40 br-5 fBold fs-14 white-color ml-15"}
                            >Generate Contract
                            </button>}
                            position="top center"
                            closeOnDocumentClick
                            contentStyle={{ padding: "0px", border: "none" }}
                          >
                          </Popup>
                        </div>
                      </div>

                    </div> */}

                    </>
                  }

                </Popup>
              </div>
            }
          </div>

        </div >
      </Sticky >
    )
  }
}

const mapStateToProps = ({ contracting, constants,rfq }) => {
  return {
    fromRoutes: contracting.fromRoutes || [],
    selectedNavBranch: constants.selectedNavBranch || {},
    allSubPlants: rfq.allSubPlants ||[],
    loader: contracting.loader,
  }
};

export default connect(mapStateToProps, null)(withRouter(CreateNewContracts));
